
import {
  Layout, Smartphone, ShieldCheck, Code2, BarChart3, Cloud, FileText,
  ArrowRight, CheckCircle2, Facebook, Twitter, Instagram, Linkedin, Mail, MapPin, Phone
} from 'lucide-react';
import { NavItem, ServiceCategory, HomePricingCard, BlogPost, FaqItem, TeamMember, Project, DemoSite } from './types';

// Blog Images
const blogImg1 = '/images/blog-1.webp';
const blogImg2 = '/images/blog-2.webp';
const blogImg3 = '/images/blog-3.webp';
const blogImg4 = '/images/blog-4.webp';
const blogImg5 = '/images/blog-5.webp';
const blogImg6 = '/images/blog-1.webp';
const blogImg7 = '/images/blog-7.webp';
const blogImg8 = '/images/blog-8.webp';
const blogImg9 = '/images/blog-1.webp';
const blogWordPress = '/images/blog-wordpress-vs-custom.webp';
const blogCheapWebsite = '/images/blog-10-websitesi-maliyeti.webp';
const blogTesisYonetimi = '/images/blog-tesis-yonetimi.webp';
const blogWebRaporlama = '/images/blog-web-raporlama.webp';
const blogHukukYonetimi = '/images/blog-hukuk-yonetimi.webp';
const blogEticaret = '/images/blog-eticaret.webp';
const blogSporRezervasyon = '/images/blog-spor-rezervasyon.webp';

// Project Images

// Corex Project Images
const corexImg1 = '/images/websitesi-corexbomonti.webp';
const corexImg2 = '/images/websitesi-corexbomonti2.webp';
const corexImg3 = '/images/websitesi-corexbomonti3.webp';

// MH Dizayn Project Images
const mhImg1 = '/images/websitesi-mhdizayn.webp';
const mhImg2 = '/images/websitesi-mhdizayn2.webp';
const mhImg3 = '/images/websitesi-mhdizayn3.webp';

// LLD Hukuk Project Images
const lldImg1 = '/images/websitesi-lldhukuk.webp';
const lldImg2 = '/images/websitesi-lldhukuk2.webp';
const lldImg3 = '/images/websitesi-lldhukuk3.webp';

// References
const refCorex = '/images/ref-corex.webp';
const refMh = '/images/ref-mh.webp';
const refLld = '/images/ref-lld.webp';
const refAktueryal = '/images/ref-aktueryal.webp';

// Team
const cerenImg = '/images/ceren.webp';
const ahmetImg = '/images/ahmet.webp';
export const NAV_ITEMS: NavItem[] = [
  { label: 'Anasayfa', path: '/' },
  { label: 'Hakkımızda', path: '/hakkimizda' },
  { label: 'Hizmetlerimiz', path: '/hizmetlerimiz' },
  { label: 'Projelerimiz', path: '/projelerimiz' },
  { label: 'Blog', path: '/blog' },
  { label: 'İletişim', path: '/iletisim' },
];

export const SERVICE_CATEGORIES: ServiceCategory[] = [
  {
    id: "web-dev",
    language: 'TR',
    slug: 'web-gelistirme',
    title: 'Web Geliştirme',
    description: 'İhtiyacınıza göre dizayn edilmiş bir web sitesi ile kendi işinizi bir adım öteye taşıyın.',
    icon: 'Layout',
    features: [
      'SEO dostu',
      'Mobil uyumlu',
      'Kurumsal Web Siteleri',
      'CMS Entegrasyonu'
    ],
    packages: [
      {
        id: "web-basic",
        name: 'Temel Web Sitesi',
        description: 'Modern anasayfa tasarımı ile ihtiyacınıza özel tek sayfalık web sitesi',
        price: '11.900₺',
        priceSuffix: "'den başlayan fiyatlar *",
        features: [
          'Markanızın kimliğini yansıtacak one-page site tasarımı',
          'Hızlı ve modern görünüm',
          'Mobil uyumlu web sitesi',
          'Yapay zeka destekli görseller ve içerikler'
        ],
        footnote: '* Ek sayfa bedeli 2500₺’dir. Fiyata host, domain ücretleri ve vergiler dahil değildir.',
        badge: 'Hızlı ve Ekonomik'
      },
      {
        id: "web-advanced",
        name: 'Detaylı Web Sitesi',
        description: 'İhtiyacınıza yönelik 3 sayfaya kadar özelleştirilmiş web sitesi',
        price: '23.900₺',
        priceSuffix: "'den başlayan fiyatlar *",
        features: [
          'Markanıza özel 3 alt sayfadan oluşan site tasarımı',
          'Arama motorlarında üstlere çıkmak için SEO çalışmaları',
          'Hızlı ve modern görünüm',
          'Tüm mobil cihazlara uyumlu web sitesi',
          'Yapay zeka destekli görseller ve içerikler',
          'Markanıza özel renk paletleri'
        ],
        isPopular: true,
        footnote: '* Ek sayfa bedeli 2500₺’dir. Fiyata host, domain ücretleri ve vergiler dahil değildir.',
        badge: 'Tasarruflu Paket'
      },
      {
        id: "web-custom",
        name: 'Size Özel Web Sitesi',
        description: 'İşinizi geliştirmek için ihtiyaç duyduğunuz tüm özellikleri barındıracak web sitesi',
        price: 'Özel Fiyatlar',
        features: [
          'Markanızın ve işinizin ihtiyacı olan tüm noktalar için web çözümleri',
          'Arama motorlarında üstlere çıkmak için SEO çalışmaları',
          'Rezervasyon sistemleri, menü tasarımları, e-ticaret sistemleri, üye yönetim panelleri gibi tüm ihtiyaçlara yönelik sınırsız hizmet',
          '6 aylık bakım garantisi',
          'İşinize özel keywordler ile zenginleştirilmiş içerikler ve blog yazıları',
          'İş yerinize özel görseller',
          'Markanız için logo tasarımı'
        ],
        badge: 'Kişiye Özel'
      }
    ]
  },
  {
    id: "mobile-app",
    language: 'TR',
    slug: 'mobil-uygulama',
    title: 'Mobil Uygulama',
    description: 'Kullanıcı dostu ve esnek mobil uygulamalarla markanızı her an her yerde erişilebilir kılın.',
    icon: 'Smartphone',
    features: [
      'Çapraz Platform Uyumlu',
      'Kullanıcı Deneyimi Öncelikli',
      'iOS & Android',
      'Mobil UI/UX Tasarım'
    ],
    packages: [
      {
        id: "mobile-basic",
        name: 'Başlangıç Paketi',
        description: 'Küçük işletmeler ve MVP projeleri için ideal çözüm',
        price: '35.900₺',
        priceSuffix: "'den başlayan fiyatlar *",
        features: [
          'React Native veya Flutter ile geliştirilen temel çapraz platform uygulama',
          '4 sabit sayfa (Ana Sayfa, Hakkımızda, İletişim, Hizmetler vb.)',
          'Firebase ile kullanıcı kaydı/girişi ve basit veri yönetimi',
          'Push bildirim entegrasyonu (OneSignal veya Firebase üzerinden)',
          "App Store ve Google Play'e yükleme desteği",
          'Basit admin panel entegrasyonu (örneğin içerik güncelleme için)',
          'Marka renkleri ve logonuzla uyumlu özel tasarım'
        ],
        footnote: "* Ek sayfa bedeli 5000₺'dir. Fiyata vergiler dahil değildir.",
        badge: 'Ekonomik'
      },
      {
        id: "mobile-advanced",
        name: 'Gelişmiş Paket',
        description: 'Daha büyük projeler ve işlevsel uygulamalar için kapsamlı çözüm',
        price: 'Özel Fiyatlar',
        features: [
          'React Native veya Flutter tabanlı tam kapsamlı uygulama geliştirme',
          'Sınırsız sayfa ve modül (profil, galeri, rezervasyon, ödeme, harita, yorum sistemi vb.)',
          'Stripe, PayTR, iyzico gibi ödeme sistemleriyle entegrasyon',
          'Canlı veri takibi (ör. rezervasyon, stok, içerik güncelleme)',
          'QR kod okuma, harita, kamera, dosya yükleme gibi cihaz özellikleri entegrasyonu',
          'Detaylı admin panel bağlantısı (içerik yönetimi, kullanıcı listesi, veri istatistikleri)',
          'Çok dilli destek ve karanlık mod seçeneği',
          'İlk 3 ay boyunca güncelleme ve bakım desteği'
        ],
        isPopular: true,
        footnote: "Müşteri istekleri alındıktan sonra projenin analizleri yapılır. Yapılacak iş, projenin büyüklüğü, teslim süresi ve proje maliyeti ilk görüşmeden sonra en geç 5 iş günü içerisinde raporlanarak müşteriye sunulur.",
        badge: 'Premium'
      }
    ]
  },
  {
    id: "it-consultancy",
    language: 'TR',
    slug: 'it-danismanlik',
    title: 'IT Danışmanlık',
    description: 'Markanızın iş süreçlerine özel olarak tasarlanmış stratejik IT çözümleriyle dijital dünyada fark yaratın.',
    icon: 'ShieldCheck',
    features: [
      'Dijital Strateji Geliştirme',
      'Verimli Teknoloji Kullanımı',
      'Süreç Analizi',
      'Güvenlik Denetimi'
    ],
    packages: [
      {
        id: "consultancy-basic",
        name: 'IT Danışmanlık',
        description: 'Dijital dönüşüm süreçlerinizde profesyonel yol haritası',
        price: 'Özel Fiyatlar',
        features: [
          'Mevcut teknolojik altyapının analizi ve raporlanması',
          'Dijital dönüşüm stratejilerinin belirlenmesi',
          'Siber güvenlik risk analizi ve önlemleri',
          'Bulut sistemlere geçiş (Cloud Migration) planlaması',
          'Maliyet optimizasyonu ve verimlilik artırma çalışmaları',
          'Personel yetkinlik analizi ve eğitim planlaması'
        ],
        footnote: "* Proje kapsamına göre fiyatlandırma yapılmaktadır.",
        badge: 'Stratejik'
      },
      {
        id: "custom-soft-basic",
        name: 'Özel Yazılım',
        description: 'İş süreçlerinize tam uyumlu, size özel yazılım çözümleri',
        price: 'Özel Fiyatlar',
        features: [
          'İhtiyaç analizi ve teknik şartname oluşturma',
          'CRM, ERP, Stok Takip gibi kurumsal otomasyonlar',
          'Mevcut sistemlerle (API) tam entegrasyon',
          'Ölçeklenebilir ve güvenli mimari tasarımı',
          'Kullanıcı dostu arayüz (UI/UX) tasarımı',
          'Düzenli bakım ve teknik destek hizmeti'
        ],
        isPopular: true,
        footnote: "* Proje kapsamına göre fiyatlandırma yapılmaktadır.",
        badge: 'İhtiyaca Yönelik'
      },
      {
        id: "data-basic",
        name: 'Veri Analizi',
        description: 'Verilerinizi anlamlı bilgilere dönüştürerek karar süreçlerinizi güçlendirin',
        price: 'Özel Fiyatlar',
        features: [
          'Büyük veri (Big Data) işleme ve anlamlandırma',
          'İş zekası (BI) raporlama panelleri (PowerBI, Tableau)',
          'Müşteri davranış analizi ve segmentasyon',
          'Satış tahminleme ve trend analizleri',
          'Veri temizleme ve düzenleme hizmetleri',
          'Veri güvenliği ve KVKK uyumluluk danışmanlığı'
        ],
        footnote: "* Proje kapsamına göre fiyatlandırma yapılmaktadır.",
        badge: 'İçgörü'
      }
    ]
  },
  {
    id: "custom-software",
    language: 'TR',
    slug: 'ozel-yazilim',
    title: 'Özel Yazılım',
    description: 'Şirketinizin ihtiyaçlarına özel, ölçeklenebilir yazılım mimarileri tasarlıyoruz.',
    icon: 'Code2',
    features: [
      'CRM/ERP Çözümleri',
      'Otomasyon Sistemleri',
      'API Entegrasyonları',
      'Mikroservis Mimarisi'
    ],
    packages: []
  },
  {
    id: "data-analysis",
    language: 'TR',
    slug: 'veri-analizi',
    title: 'Veri Analizi',
    description: 'Büyük veriyi işleyerek işletmenizin ihtiyacı olan anlamlı raporlara dönüştürüp, içgörüler sunuyoruz.',
    icon: 'BarChart3',
    features: [
      'Big Data İşleme',
      'İş Zekası (BI)',
      'Veri Görselleştirme',
      'Raporlama Sistemleri'
    ],
    packages: []
  },
  {
    id: "ui-ux",
    language: 'TR',
    slug: 'ui-ux-raporlama',
    title: 'UI/UX Raporlama',
    description: 'Kullanıcı deneyimini analiz ederek, arayüzlerinizi optimize ediyor ve dönüşüm oranlarınızı artırıyoruz.',
    icon: 'FileText',
    features: [
      'Kullanıcı Testleri',
      'Arayüz Analizi',
      'Dönüşüm Optimizasyonu',
      'Erişilebilirlik Raporu'
    ],
    packages: []
  }
];

export const HOME_PRICING_CARDS: HomePricingCard[] = [
  {
    id: "home-web",
    language: 'TR',
    title: 'Web Sitesi',
    description: 'Modern tasarımlar ve optimize altyapılarla ihtiyacınıza özel web çözümleri sunuyoruz',
    price: '11.900₺',
    priceSuffix: "'den başlayan fiyatlar *",
    features: [
      'Markanızın ve işinizin ihtiyacı olan tüm noktalar için web çözümleri',
      'Arama motorlarında üstlere çıkmak için SEO çalışmaları',
      'Rezervasyon sistemleri, menü tasarımları, e-ticaret sistemleri, üye yönetim panelleri gibi tüm ihtiyaçlara yönelik sınırsız hizmet',
      'Hızlı ve modern görünüm',
      'Mobil cihazlara uyumlu web sitesi',
      '6 aylık bakım garantisi',
      'İşinize özel keywordler ile zenginleştirilmiş içerikler ve blog yazıları',
      'İş yerinize özel görseller',
      'Markanız için logo tasarımı ve markanıza özel renk paletleri'
    ],
    linkTo: '/hizmetlerimiz',
    footnote: '*Başlangıç paket fiyatıdır. Fiyata host, domain ücretleri ve vergiler dahil değildir.'
  },
  {
    id: "home-mobile",
    language: 'TR',
    title: 'Mobil Uygulama',
    description: 'iOS ve Android platformları için performanslı ve ölçeklenebilir mobil uygulamalar geliştiriyoruz',
    price: '35.900₺',
    priceSuffix: "'den başlayan fiyatlar *",
    features: [
      'React Native veya Flutter tabanlı tam kapsamlı uygulama geliştirme',
      'Sınırsız sayfa ve modül (profil, galeri, rezervasyon, ödeme, harita, yorum sistemi vb.)',
      'Stripe, PayTR, iyzico gibi ödeme sistemleriyle entegrasyon',
      'Canlı veri takibi (ör. rezervasyon, stok, içerik güncelleme)',
      'QR kod okuma, harita, kamera, dosya yükleme gibi cihaz özellikleri entegrasyonu',
      'Detaylı admin panel bağlantısı (içerik yönetimi, kullanıcı listesi, veri istatistikleri)',
      'Çok dilli destek ve karanlık mod seçeneği',
      'İlk 3 ay boyunca güncelleme ve bakım desteği'
    ],
    isPopular: true,
    linkTo: '/hizmetlerimiz',
    footnote: '* Sunulan fiyat, temel MVP (Minimum Viable Product) sürümünü kapsar. Fiyata vergiler dahil değildir.'
  },
  {
    id: "home-consult",
    language: 'TR',
    title: 'IT Danışmanlık',
    description: 'Şirketinizin dijital dönüşüm süreçlerinde güvenilir bir çözüm ortağı oluyoruz',
    price: 'Özel Fiyatlar',
    features: [
      'Altyapı analizi, sistem kurulumu ve siber güvenlik değerlendirmesi',
      'Bulut teknolojileri (AWS, Google Cloud, Azure) üzerine kurulum ve geçiş danışmanlığı',
      'Yazılım geliştirme süreçlerinde teknoloji seçimi ve proje yönetimi desteği',
      'Ekip içi teknik eğitimler, dökümantasyon ve süreç standardizasyonu hizmetleri',
      'Veri tabanı iyileştirme hizmeti',
      'UX/UI analizi ve raporlaması',
      'Siber güvenlik eğitimleri ve danışmanlığı',
      'Projelerinize geçici yazılımcı desteği'
    ],
    linkTo: '/hizmetlerimiz',
    footnote: '* Danışmanlık saat bazlı verilir. Talebe göre aylık paketler oluşturulabilir.'
  }
];

export const BLOG_POSTS: BlogPost[] = [
    {
      id: 15,
      slug: 'spor-studyolarinda-operasyonel-mukemmellik-uye-kredi-ve-akilli-rezervasyon-sistemleri',
      title: 'Spor Stüdyolarında Operasyonel Mükemmellik: Üye, Kredi ve Akıllı Rezervasyon Sistemleri',
      excerpt: 'Spor ve wellness işletmelerinin tüm iş akışını tek bir ekrandan pürüzsüzce yönetebilecekleri, yüksek mühendislik standartlarına sahip Özel Stüdyo Yönetim ve Rezervasyon Panelleri.',
      date: '29 Haziran 2026',
      image: blogSporRezervasyon,
      category: 'Stüdyo Yönetim Yazılımları / SaaS',
      author: 'Pato Yazılım Ekibi',
      readTime: '3 dk',
      content: `
        <p class="mb-4">Pilates, yoga, crossfit veya kişisel antrenman (PT) stüdyolarını yönetmek; sadece spor yaptırmaktan çok daha fazlasıdır. İptal edilen dersler, takibi unutulan üyelik paketleri, ders kredisi tükenen üyeler ve telefon trafiği arasında sıkışan randevu süreçleri... Birçok stüdyo sahibi ve yöneticisi, günün büyük bölümünü sporcularıyla ilgilenmek yerine bu operasyonel karmaşayı çözmek için harcar.</p>
        <p class="mb-4">Pato Yazılım olarak; spor ve wellness işletmelerinin tüm iş akışını tek bir ekrandan pürüzsüzce yönetebilecekleri, yüksek mühendislik standartlarına sahip Özel Stüdyo Yönetim ve Rezervasyon Panelleri geliştiriyoruz.</p>
        <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Dijital Rezervasyon ve Üye Yönetiminin Gücü</h3>
        <ol class="list-decimal pl-5 space-y-4 mb-6">
          <li><strong>Akıllı Kredi ve Paket Takip Sistemi:</strong> Üyelerinizin satın aldığı ders paketlerini, kalan kredilerini ve üyelik sürelerini sistem otomatik olarak takip eder. Kredisi azalan veya üyeliği bitmek üzere olan sporculara otomatik bildirimler giderek işletmenizin sürekliliğini sağlar.</li>
          <li><strong>7/24 Kesintisiz Rezervasyon Paneli:</strong> Telefon veya mesaj trafiğine son. Üyeleriniz doğrudan web siteniz veya mobil uyumlu paneliniz üzerinden boş saatleri, eğitmen takvimlerini görebilir ve kendi randevularını (bireysel veya grup dersi) saniyeler içinde oluşturabilir.</li>
          <li><strong>Esnek İptal ve Kontenjan Algoritmaları:</strong> Stüdyonuzun kurallarına göre (örneğin: "Ders saatine son 2 saat kala iptal edilemez") çalışan akıllı algoritmalar sayesinde, son dakika iptallerinin önüne geçer ve kontenjan kaybı yaşamazsınız. Yedek liste yönetimiyle boşalan yerler otomatik olarak diğer üyelere sunulur.</li>
          <li><strong>Yönetici Özeti ve Finansal Raporlama:</strong> Hangi eğitmenin kaç ders doldurduğunu, stüdyonun en yoğun saatlerini, aylık ciro ve tahsilat durumlarını tek bir şık Dashboard (Yönetici Paneli) üzerinden anlık olarak analiz edebilirsiniz.</li>
        </ol>
        <p class="mb-4">Spor stüdyonuzun prestijini artırmak, yönetim yükünü sıfıra indirmek ve üyelerinize premium bir dijital deneyim sunmak için hazır yazılımların sınırlarına bağlı kalmayın. İşletmenize özel geliştirilecek akıllı yönetim sistemleri için Pato Yazılım ile iletişime geçin.</p>
      `
    },
    {
      id: 14,
      slug: 'e-ticarette-siradanligi-asin-ozel-yazilim-altyapilari-ile-sinirsiz-buyume',
      title: 'E-Ticarette Sıradanlığı Aşın: Özel Yazılım Altyapıları ile Sınırsız Büyüme',
      excerpt: 'E-ticareti kalıplardan kurtarıyoruz. Markanızın kimliğine tam uyum sağlayan, hız ve dönüşüm odaklı Özel E-Ticaret Yazılım Altyapıları ile dijital mağazanızı küresel standartlara taşıyoruz.',
      date: '28 Haziran 2026',
      image: blogEticaret,
      category: 'E-Ticaret Altyapıları / Dijital Dönüşüm',
      author: 'Pato Yazılım Ekibi',
      readTime: '3 dk',
      content: `
        <p class="mb-4">E-ticaret dünyasında rekabet her geçen gün zorlaşıyor. Artık sadece bir ürüne ve standart bir web sitesine sahip olmak, dijital pazarda öne çıkmak için yeterli değil. Birçok marka, e-ticarete başlarken hazır paket şablonları tercih ediyor. Ancak marka büyüdükçe, bu hazır sistemlerin getirdiği katı sınırlar, yavaş yüklenme süreleri ve birbirini tekrar eden tasarımlar e-ticaret operasyonlarını kısıtlamaya başlıyor.</p>
        <p class="mb-4">Pato Yazılım olarak, e-ticareti kalıplardan kurtarıyoruz. Markanızın kimliğine tam uyum sağlayan, hız ve dönüşüm odaklı Özel E-Ticaret Yazılım Altyapıları ile dijital mağazanızı küresel standartlara taşıyoruz.</p>
        <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Özel E-Ticaret Mühendisliği Neler Sunar?</h3>
        <ol class="list-decimal pl-5 space-y-4 mb-6">
          <li><strong>Özgür ve Premium Tasarım Dili (UI/UX):</strong> Hazır şablonların tekdüzeliğinden sıyrılarak, hedef kitlenizin satın alma alışkanlıklarına göre optimize edilmiş, tamamen markanıza özel, lüks ve estetik bir arayüz inşa ediyoruz.</li>
          <li><strong>Maksimum Sayfa Hızı ve Kusursuz SEO:</strong> E-ticarette 1 saniyelik bir gecikme bile sepeti terk etme oranlarını %20 artırır. İleri düzey ön yüz mühendisliği ve sunucu optimizasyonlarımız sayesinde, binlerce ürününüz olsa dahi saniyeler içinde açılan ve Google arama motorlarında hızla yükselen altyapılar sunuyoruz.</li>
          <li><strong>Gelişmiş Filtreleme ve Esnek Mimari:</strong> Kullanıcıların aradıkları ürüne, bedene veya renge anında ulaşabilmeleri için modern filtreleme sistemleri kurguluyoruz. Sayfa yenilenmeden çalışan bu akış, müşteri deneyimini en üst seviyeye çıkarıyor.</li>
          <li><strong>Geleceğe Hazır (AI-Readiness) Yapı:</strong> Dijital mağazanızı, yeni nesil yapay zeka arama motorlarının (Perplexity, SearchGPT vb.) ürünlerinizi doğrudan tanıyıp potansiyel alıcılara "kaynak ürün" olarak önerebileceği teknik semantik şemalarla donatıyoruz.</li>
        </ol>
        <p class="mb-4">Dijital dünyada kendi kurallarınızı koymak ve sınırları olmayan, yüksek performanslı bir e-ticaret platformuyla cironuzu katlamak istiyorsanız; Pato Yazılım’ın kurumsal e-ticaret çözümleriyle hemen tanışın.</p>
      `
    },
    {
      id: 13,
      slug: 'hukuk-burolari-icin-web-sitesi-sadece-bir-vitrin-degildir-dinamik-icerik-yonetimi-neden-sart',
      title: 'Hukuk Büroları İçin Web Sitesi Sadece Bir Vitrin Değildir: Dinamik İçerik Yönetimi Neden Şart?',
      excerpt: 'Sadece premium bir tasarım değil, aynı zamanda avukatların dijital varlıklarını saniyeler içinde yönetebileceği Özel İçerik Yönetim Panelleri (CMS) ile büronuzun dijital dönüşümünü hızlandırın.',
      date: '27 Haziran 2026',
      image: blogHukukYonetimi,
      category: 'Hukuk Teknolojileri / LegalTech CMS',
      author: 'Pato Yazılım Ekibi',
      readTime: '3 dk',
      content: `
        <p class="mb-4">Hukuk sektörü, doğası gereği dinamik ve zamanla yarışılan bir dünyadır. Yeni çıkan bir torba yasa, kritik bir Yargıtay kararı veya uluslararası ticaretteki ani bir mevzuat değişikliği, müvekkillerinizin anlık olarak bilmesi gereken hayati bilgilerdir. Ancak birçok hukuk bürosu, kurumsal kimliklerine yakışan şık bir web sitesine sahip olsa da, bu siteyi güncel tutma konusunda ciddi operasyonel hantallıklar yaşamaktadır.</p>
        <p class="mb-4">Bir makale yayınlamak veya faaliyet alanına yeni bir madde eklemek için günlerce teknik destek veya yazılım ajansı beklemek, dijital çağda kabul edilebilir bir hız değildir. Pato Yazılım olarak; üst düzey hukuk büroları için sadece premium bir tasarım değil, aynı zamanda avukatların dijital varlıklarını saniyeler içinde yönetebileceği Özel İçerik Yönetim Panelleri (CMS) inşa ediyoruz.</p>
        <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Dinamik Yönetim Paneli Hukuk Bürolarına Ne Kazandırır?</h3>
        <ol class="list-decimal pl-5 space-y-4 mb-6">
          <li><strong>Sıfır Teknik Bilgiyle Anında Yayın Alma Özgürlüğü:</strong> Özel geliştirdiğimiz kurumsal paneller sayesinde, büronuzdaki herhangi bir avukat hiçbir kod veya tasarım bilgisine ihtiyaç duymadan sisteme giriş yapabilir. Önemli bir hukuki gelişme yaşandığında, hazırlanan makaleyi tıpkı bir e-posta yazar gibi panele ekleyip saniyeler içinde yayına alabilirsiniz. Böylece müvekkillerinize güncel bilgiyi rakiplerinizden çok daha önce sunarsınız.</li>
          <li><strong>Faaliyet Alanları ve Uzman Kadro Yönetimi:</strong> Büronuza yeni bir ortak/avukat katıldığında veya hizmet alanlarınıza "Kişisel Verilerin Korunması Hukuku" gibi yeni bir departman eklendiğinde, dışarıdan destek beklemenize gerek kalmaz. Yönetim paneli üzerinden yeni avukat profillerini (özgeçmiş, uzmanlık ve iletişim bilgileriyle birlikte) kolayca ekleyebilir, faaliyet alanlarınızı anlık olarak güncelleyebilirsiniz.</li>
          <li><strong>Karmaşık Verilerin Kusursuz Eşleşmesi:</strong> Bir avukatın profilini, o avukatın yazdığı makalelerle veya ilgilendiği faaliyet alanlarıyla otomatik olarak ilişkilendirebilirsiniz. Örneğin; bir müvekkil sitenizdeki "Deniz Ticareti Hukuku" sayfasını okurken, sistem arka planda o alanda uzman olan avukatlarınızı ve yazdıkları güncel bültenleri ziyaretçiye akıllıca sunar.</li>
          <li><strong>Yapay Zeka Uyumlu ve SEO Odaklı Altyapı:</strong> Yayınladığınız makaleler sadece web sitenizde durmaz; Pato Yazılım’ın kurduğu modern altyapı sayesinde, bu içerikler Google ve yeni nesil yapay zeka arama motorları tarafından saniyeler içinde doğru bir şekilde indekslenir. Doğru yapılandırılmış bir sistem, hukuki makalelerinizin organik aramalarda en üst sıralara çıkmasını sağlar.</li>
        </ol>
        <p class="mb-4">Bir hukuk bürosunun web sitesi statik bir broşür olamaz; markanızın vizyonunu yansıtan, yaşayan ve güncel bir dijital ofis olmalıdır. Büronuzun dijital dönüşümünü hızlandırmak, içeriklerinizi tam kontrol altına almak ve Pato Yazılım'ın kurumsal hukuk çözümleriyle tanışmak için bizimle iletişime geçebilirsiniz.</p>
      `
    },
    {
      id: 12,
      slug: 'akilli-tesis-ve-site-yonetiminde-dijital-donusum-yapay-zeka-destekli-raporlama-panelleri',
      title: 'Akıllı Tesis ve Site Yönetiminde Dijital Dönüşüm: Yapay Zeka Destekli Raporlama Panelleri',
      excerpt: 'Tesis yönetiminde dijital dönüşümü "operasyonel yükten" çıkarıp "stratejik zekaya" dönüştürüyoruz. Geleceği öngören yapay zeka destekli Yönetici Raporlama Panelleri ile tanışın.',
      date: '26 Haziran 2026',
      image: blogTesisYonetimi,
      category: 'Akıllı Tesis Yönetimi / Dashboard',
      author: 'Pato Yazılım Ekibi',
      readTime: '3 dk',
      content: `
        <p class="mb-4">Büyük ölçekli konut projeleri, plazalar ve rezidanslar her gün devasa bir veri üretir. Aidat tahsilatları, enerji tüketimi, personel vardiyaları ve teknik arıza kayıtları... Geleneksel tesis yönetimi süreçlerinde bu veriler genellikle karmaşık Excel tabloları veya arayüzü hantal, eski nesil operasyonel yazılımlar arasına sıkışıp kalır. Oysa modern bir yönetim kurulunun veya tesis yöneticisinin ihtiyacı olan şey veri girmek değil, veriyi saniyeler içinde okuyup stratejik kararlar alabilmektir.</p>
        <p class="mb-4">Pato Yazılım olarak, tesis yönetiminde dijital dönüşümü "operasyonel yükten" çıkarıp "stratejik zekaya" dönüştürüyoruz. Sadece günü kurtaran değil, geleceği öngören yapay zeka destekli Yönetici Raporlama Panelleri (Executive Dashboards) ile tesis yönetimini yeni bir boyuta taşıyoruz.</p>
        <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Neden Yeni Nesil Bir Panele İhtiyacınız Var?</h3>
        <ol class="list-decimal pl-5 space-y-4 mb-6">
          <li><strong>Karmaşadan Uzak, Finansal Zeka Ekranı:</strong> Yüzlerce sayfalık muhasebe dökümleri yerine; sitenizin veya plazanızın gelir-gider dengesini, aidat tahsilat hızını ve bütçe sapmalarını tek bir ekranda, şık ve anlaşılır grafiklerle (Veri Görselleştirme) sunuyoruz.</li>
          <li><strong>Yapay Zeka ile Kestirimci Bakım (Predictive Maintenance):</strong> Klasik sistemler asansör bozulduğunda size haber verir. Pato Yazılım’ın entegre edebileceği yapay zeka algoritmaları ise geçmiş arıza verilerini analiz ederek, "B Blok asansörünün motor bakımı önümüzdeki ay yapılmazsa arıza riski %80" şeklinde sizi önceden uyarır. Bu sayede sürpriz maliyetlerin önüne geçersiniz.</li>
          <li><strong>Enerji ve Sürdürülebilirlik Takibi:</strong> Ortak alanlardaki elektrik, su ve doğalgaz tüketimlerini önceki aylar ve yıllarla kıyaslayan akıllı paneller sayesinde, tesisinizin karbon ayak izini ve enerji israfını tespit edip hızla aksiyon alabilirsiniz.</li>
        </ol>
        <p class="mb-4">Pato Yazılım olarak, paket yazılımların kalıplarına sığmayan tesisler için tamamen kurumun ihtiyaçlarına (terzi işi) özel, yüksek güvenlikli ve modern bulut tabanlı raporlama panelleri inşa ediyoruz. Yönetim süreçlerinizi yapay zeka destekli bir vizyonla geleceğe taşımak için bizimle iletişime geçin.</p>
      `
    },
    {
      id: 11,
      slug: 'web-siteniz-sadece-bir-vitrin-mi-yeni-nesil-dijital-performans-ve-raporlama-panelleri',
      title: 'Web Siteniz Sadece Bir Vitrin Mi? Yeni Nesil Dijital Performans ve Raporlama Panelleri',
      excerpt: 'Kurumsal web projelerini sadece yüksek hız ve premium tasarımla yayına almakla kalmıyor, markalara dijital varlıklarını tek bir merkezden okuyabilecekleri Özel Dijital Dönüşüm ve Raporlama Panelleri sunuyoruz.',
      date: '25 Haziran 2026',
      image: blogWebRaporlama,
      category: 'Kurumsal Web Teknolojileri / Raporlama',
      author: 'Pato Yazılım Ekibi',
      readTime: '4 dk',
      content: `
        <p class="mb-4">Günümüzde modern bir şirketin web sitesi sadece dijital bir broşür değil; markanın en yetenekli satış temsilcisi ve 7/24 çalışan iletişim merkezidir. Ancak pek çok şirket yöneticisi "Sitemiz bize ne kadar para kazandırıyor? Hangi kampanyamız daha çok form doldurttu? Sitemiz yeterince hızlı mı?" sorularının cevabını bulmak için karmaşık Google Analytics (GA4) ekranlarında kaybolur. Yöneticilerin veri analisti olmasına gerek yoktur; onlara net, yorumlanmış ve eyleme dökülebilir bilgiler gerekir.</p>
        <p class="mb-4">Pato Yazılım olarak; kurumsal web projelerini sadece yüksek hız ve premium tasarımla yayına almakla kalmıyor, markalara dijital varlıklarını tek bir merkezden okuyabilecekleri Özel Dijital Dönüşüm ve Raporlama Panelleri sunuyoruz.</p>
        <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Pato Yazılım Raporlama Panelleri Ne Sunar?</h3>
        <ol class="list-decimal pl-5 space-y-4 mb-6">
          <li><strong>Tek Ekran Zekası (Unified Dashboard):</strong> Farklı platformlara şifre girerek vakit kaybetmeye son. Arama motoru organik sıralamalarınızı (SEO), anlık ziyaretçi trafiğinizi ve iletişim formlarından gelen potansiyel müşteri verilerinizi (Lead) şık grafiklerle doğrudan kendi sitenizin yönetim panelinden takip edebilirsiniz.</li>
          <li><strong>Yapay Zeka Destekli Yönetici Özeti (AI Insights):</strong> Elde edilen ham veriler, sisteminize entegre ettiğimiz yapay zeka asistanı tarafından okunur ve size haftalık raporlar halinde sunulur: "Geçen aya göre mobil trafiğiniz %15 arttı, form doldurma oranınız yükseldi. Organik aramalarda 'kurumsal danışmanlık' kelimesinde 3 sıra yükseldiniz."</li>
          <li><strong>Entegre Müşteri Havuzu (Mini CRM):</strong> Web sitenizden doldurulan tüm iletişim ve teklif formları, e-posta kutunuzun karmaşasından kurtarılarak doğrudan raporlama panelinize düşer. Gelen talepleri panel üzerinden "İnceleniyor", "Dönüş Yapıldı" olarak işaretleyip şirket içi operasyonunuzu hızlandırabilirsiniz.</li>
          <li><strong>Site Sağlık Monitörü:</strong> Platformunuzun anlık sunucu durumu (Uptime), sayfa açılış hızları ve mobil uyumluluk skorları canlı olarak panelinize yansır. Böylece dijital vitrininizin her zaman %100 performansla çalıştığından emin olursunuz.</li>
        </ol>
        <p class="mb-4">Web sitenizin sadece görünümünü değil, arkasındaki zekayı da en ileri yazılım standartları ve modern mühendislik yaklaşımlarıyla tasarlıyoruz. Şirketinizin dijital varlıklarını ölçülebilir ve kârlı bir yatırıma dönüştürecek özel yönetim panelleri için Pato Yazılım ile hemen tanışın.</p>
      `
    },
  {
    id: 10,
    slug: 'wordpress-devri-bitiyor-mu-ozel-yazilim-vs-hazir-sistem',
    title: 'WordPress Devri Bitiyor mu? İşletmeniz İçin Neden Özel Yazılım Seçmelisiniz?',
    excerpt: 'Web siteniz dijital mağazanızdır. Hazır şablonlar mı yoksa size özel dikilmiş bir dijital takım elbise mi? Custom Code avantajlarını inceliyoruz.',
    date: '05 Şubat 2026',
    image: blogWordPress,
    category: 'Özel Yazılım Çözümleri / Custom Code',
    author: 'Pato Yazılım Ekibi',
    readTime: '5 dk',
    content: `
      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Web Siteniz Dijital Mağazanızdır: Neden "Özel Dikim" (Custom Code) Tercih Etmelisiniz?</h3>
      <p>Dijital dünyada bir müşterinin sitenizde kalıp kalmayacağına karar vermesi sadece 3 saniye sürer. Peki, işletmenizi temsil eden web siteniz, binlerce kişinin kullandığı hazır bir şablon mu, yoksa tamamen size özel kodlanmış bir mimari mi olmalı?</p>
      <p>Pato Yazılım olarak, müşterilerimize sıkça duyduğumuz "Neden hazır sistem (WordPress, Wix vb.) yerine özel yazılım (Custom Code) tercih etmeliyim?" sorusunu bu yazımızda şeffaflıkla yanıtlıyoruz.</p>
      <p>İşte işletmenizi rakiplerinizden ayıracak Custom Code teknolojisinin 5 hayati avantajı:</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">1. Işık Hızında Performans (Google Bunu Seviyor!) ⚡</h3>
      <p>Hazır sistemler (CMS), kullanmayacağınız binlerce özellik ve kod yığınıyla gelir. Bu, sitenizin "sırtında taş dolu bir çantayla" koşmaya çalışmasına benzer. Custom Code (Özel Yazılım) ise sadece ihtiyacınız olanı barındırır. Gereksiz tek bir satır kod yoktur.</p>
      <p>Sonuç: Siteniz milisaniyeler içinde açılır. Google, hızlı siteleri arama sonuçlarında (SEO) her zaman ödüllendirir ve en tepeye taşır.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">2. Kırılmaz Güvenlik Duvarı 🛡️</h3>
      <p>Dünyadaki web sitelerinin büyük çoğunluğu hazır sistemlerle kurulduğu için, siber saldırganlar (hackerlar) genellikle bu sistemlerin açıklarına odaklanır. Bir eklentinin güncellenmemesi bile sitenizi saldırıya açık hale getirebilir. Özel yazılımda ise kaynak kodları tamamen size aittir ve kapalı devredir. Saldırganlar sitenizin mimarisini bilmedikleri için içeri sızmaları neredeyse imkansızdır.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">3. Sınırsız Özgürlük ve Tasarım 🎨</h3>
      <p>Hazır şablonlarda "Logoyu şuraya koyamam, tema izin vermiyor" veya "Bu butonu değiştiremem" gibi cümleler duyarsınız. Sınırlarınız, temanın sınırları kadardır. Custom Code dünyasında ise sınırlar kalkar. Hayal ettiğiniz her animasyonu, her geçişi ve her fonksiyonu piksel piksel kodlayabiliriz. Markanızın kurumsal kimliğini %100 yansıtan, eşsiz bir tasarım ortaya çıkar.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">4. "Şişmeyen" ve Çökmeyen Yapı 🏗️</h3>
      <p>Siteniz büyüdükçe; yeni ürünler, yeni sayfalar eklendikçe hazır sistemler hantallaşmaya başlar. Veritabanı şişer ve site yavaşlar. React, Next.js gibi modern teknolojilerle geliştirdiğimiz özel yazılımlar ise "Ölçeklenebilir" yapıdadır. Bugün 100 ziyaretçiniz varken de, yarın 1 milyon ziyaretçiniz varken de siteniz ilk günkü performansıyla çalışır.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">5. Uzun Vadeli Yatırım Maliyeti 💰</h3>
      <p>İlk bakışta hazır sistemler daha ucuz görünebilir. Ancak sürekli bozulan eklentiler, yavaşlık nedeniyle kaybedilen müşteriler, güvenlik açıkları ve yıllık lisans ücretleri toplandığında, hazır sistemler uzun vadede "Görünmez Maliyetler" yaratır. Özel yazılım, bir kez yapılır ve ömür boyu işletmenizin demirbaşı olur.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Karar Anı: Prestij mi, Sıradanlık mı?</h3>
      <p>Eğer internette sadece "var olmak" istiyorsanız hazır sistemler işinizi görebilir. Ancak sektörü domine etmek, hızla fark yaratmak ve müşterilerinize premium bir deneyim sunmak istiyorsanız, cevap bellidir.</p>
      <p>Pato Yazılım olarak, işletmenize özel "dijital takım elbisenizi" dikmek için hazırız. Hazır kalıplara sığmaya çalışmayın, kuralları siz koyun.</p>

      <div class="bg-gray-50 border-l-4 border-brand-blue p-6 my-8 rounded-r-lg shadow-sm">
       <p class="text-xl italic text-gray-800 font-medium mb-3">🚀 Projenizi Konuşalım mı? Modern teknolojilerle tanışmak ve web sitenizi bir üst lige çıkarmak için bizimle iletişime geçin.</p>
      </div>
    `
  },
  {
    id: 11,
    slug: 'ucuza-websitesi-tuzagi-gorunmez-maliyetler-nelerdir',
    title: '"Ucuza Web Sitesi" Tuzağı: Görünmez Maliyetler Nelerdir?',
    excerpt: 'Ucuz web sitesi yaptırmanın işletmenize uzun vadede ne kadar pahalıya mal olabileceğini tüm gerçekleriyle açıklıyoruz. Sürpriz maliyetlere hazır mısınız?',
    date: '04 Şubat 2026',
    image: blogCheapWebsite,
    category: 'Web Sitesi Yatırımı / Dijital Büyüme',
    author: 'Pato Yazılım Ekibi',
    readTime: '4 dk',
    content: `
      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Web Siteniz Size Para mı Kazandırıyor, Yoksa Müşteri mi Kaybettiriyor?</h3>
      <p>Bir fiziksel mağaza açacağınızı düşünün. Tabelası kırık, vitrini tozlu, kapısı zor açılan ve ürünlerin rastgele yığıldığı bir dükkandan alışveriş yapar mıydınız? Muhtemelen hayır.</p>
      <p>Peki, dijital dünyadaki mağazanız olan web siteniz müşterilerinize nasıl bir mesaj veriyor?</p>
      <p>Pato Yazılım olarak sıkça karşılaştığımız bir durum var: İşletmeler, web tasarımını sadece "aradan çıkarılması gereken bir masraf" olarak görüyor. Oysa 2026 dünyasında web siteniz bir masraf kalemi değil, en büyük satış personelinizdir.</p>
      <p>İşte "ucuza" mâl edilen standart bir web sitesinin işletmenize ödeteceği 4 gizli bedel:</p>

    
      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">1. İlk İzlenim İçin İkinci Bir Şansınız Yoktur ⏱️</h3>
      <p>İnternet kullanıcılarının bir web sitesi hakkında hüküm vermesi sadece 0.05 saniye sürer. Evet, göz kırpma süresinden daha kısa. Hazır şablonlarla, estetikten uzak ve "eski moda" duran bir web sitesi, potansiyel müşterinize bilinçaltında şu mesajı verir: "Bu firma işine özen göstermiyor, ürünleri de kalitesiz olabilir." Özel tasarım (Custom Code) bir web sitesi ise markanızın kalitesini, duruşunu ve vizyonunu o ilk salisede müşterinin zihnine kazır.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">2. "Dönüşüm" Kaybı: Ziyaretçi Geliyor Ama Neden Aramıyor? 📉</h3>
      <p>Sitenize reklamla veya sosyal medyadan yüzlerce kişi çekebilirsiniz. Ancak siteniz yavaş açılıyorsa, mobilde butonlar kayıyorsa veya iletişim formu çalışmıyorsa o ziyaretçiler müşteri olmadan çıkar gider. Biz buna "Delik Kova Sendromu" diyoruz. Altı delik bir kovaya ne kadar su (ziyaretçi) doldurursanız doldurun, su tutamazsınız. Pato Yazılım'ın mühendislik harikası arayüzleri, ziyaretçiyi müşteriye dönüştürmek (Conversion Rate Optimization) üzerine kurgulanır.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">3. Google'ın "Görünmezlik" Cezası 👻</h3>
      <p>Ucuz web siteleri genellikle kopya kodlarla, ağır eklentilerle ve SEO hatalarıyla doludur. Google botları bu tür siteleri sevmez ve arama sonuçlarında arka sayfalara atar. 5.000 TL'ye yaptırdığınız bir site, sizi Google'da 50. sayfada bırakıyorsa aslında size maliyeti "Kaybettiğiniz binlerce potansiyel müşteri"dir. Doğru bir SEO altyapısı ve temiz kodlama, sizi vitrinin en önüne taşır.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">4. Güvenlik ve Prestij Riski 🛡️</h3>
      <p>"Merdiven altı" diye tabir edilen amatör yazılımlar, siber saldırılara karşı savunmasızdır. Müşterilerinizin sitenize girdiğinde "Bu site güvenli değil" uyarısı görmesi veya sitenizin hacklenip başka sayfalara yönlendirilmesi, yıllarca inşa ettiğiniz marka itibarını bir gecede yerle bir edebilir.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Sonuç: Maliyet mi, Yatırım mı?</h3>
      <p>Web sitesi fiyatlarını değerlendirirken şu soruyu sorun: "Ben bir gider mi yapıyorum, yoksa bir varlık mı inşa ediyorum?"</p>
      
      <p class="font-bold text-brand-blue text-lg mt-6 mb-4">İyi bir web sitesi;</p>
      <div class="space-y-4 my-10">
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 w-6 h-6 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center mt-0.5">
            <svg class="w-3.5 h-3.5 text-brand-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
          </div>
          <span class="text-gray-700 leading-relaxed">Siz uyurken satış yapar,</span>
        </div>
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 w-6 h-6 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center mt-0.5">
            <svg class="w-3.5 h-3.5 text-brand-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
          </div>
          <span class="text-gray-700 leading-relaxed">Markanızı global standartlarda temsil eder,</span>
        </div>
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 w-6 h-6 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center mt-0.5">
            <svg class="w-3.5 h-3.5 text-brand-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
          </div>
          <span class="text-gray-700 leading-relaxed">Reklam bütçenizin verimini artırır.</span>
        </div>
      </div>

      <br><p>Pato Yazılım olarak biz, sadece kod yazmıyoruz; işletmenizin dijital geleceğini inşa ediyoruz. Gelin, markanıza hak ettiği değeri verelim.</p>

      <div class="bg-gray-50 border-l-4 border-brand-blue p-6 my-8 rounded-r-lg shadow-sm">
       <p class="text-xl italic text-gray-800 font-medium mb-3">🚀 Markanızı Zirveye Taşıyalım! Sektörünüze özel analiz ve "Özel Yazılım" farkını görmek için bizimle iletişime geçin.</p>
      </div>
    `
  },
  {
    id: 4,
    slug: 'sosyal-medya-yeterli-mi',
    title: 'Sosyal Medya Yeterli mi? Web Sitesi Sahibi Olmadan Dijitalde Var Olmak Mümkün mü?',
    excerpt: 'Sosyal medya sizin kiraladığınız bir mülk, web sitesi ise sizin tapulu evinizdir. Dijital dünyada kalıcı olmanın yolları.',
    date: '05 Aralık 2025',
    image: blogImg1,
    category: 'Dijital Pazarlama / Web Varlığı',
    author: 'Pato Yazılım Ekibi',
    readTime: '4 dk',
    content: `
  <h3 class= "text-2xl font-bold text-brand-blue mt-8 mb-4" > Dijitalde Sahiplik: Kiracı mı, Ev Sahibi mi ?</h3>
      <p>Instagram, Facebook ya da TikTok üzerinden işinizi büyütmek mümkün. Ama unutmamanız gereken bir gerçek var: Bu platformların algoritmaları, kuralları ve politikaları sizin kontrolünüzde değildir.</p>

      <div class="bg-gray-50 border-l-4 border-brand-blue p-6 my-8 rounded-r-lg shadow-sm">
        <p class="text-xl italic text-gray-800 font-medium mb-3">“Sosyal medya sizin kiraladığınız bir mülk, web sitesi ise sizin tapulu evinizdir.”</p>
        <p class="text-brand-blue font-bold not-italic">— Rand Fishkin, Moz Kurucusu</p>
      </div>
      <br><p>Bir gün algoritma değişir, erişiminiz düşer. Bir paylaşım yanlış anlaşılır, hesabınız askıya alınır. Ve işte o zaman fark edersiniz ki, aslında size ait olmayan bir zemine yatırım yapmışsınız.</p>
      
      <p>Oysa bir web sitesi size aittir. Alan adınız, içeriğiniz, veri tabanınız… Bunların hepsi sizin mülkünüzdür. Ve bu sahiplik, marka güvenilirliğinin temelidir.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Profesyonellik ve Güven</h3>
      <p>Düşünün, bir kullanıcı markanızı Instagram’da gördü. Profilinize girdi. İlk sorusu şu olur: <strong>“Web siteleri var mı?”</strong></p>
      <p>Çünkü insanlar hâlâ web sitesine sahip olan işletmeleri daha profesyonel ve güvenilir buluyor. Sadece sosyal medyada olan bir markayla, güçlü bir web sitesi olan bir marka arasında imaj farkı çok büyüktür. Web siteniz, sizin vitrin değil, dijital merkezinizdir.</p>

      <div class="bg-gray-50 border-l-4 border-brand-blue p-6 my-8 rounded-r-lg shadow-sm">
        <p class="text-xl italic text-gray-800 font-medium mb-3">“Dijital dünyada güven, hızla gelir; ama kalıcılığı web siteniz belirler.”</p>
        <p class="text-brand-blue font-bold not-italic">— Brian Clark, Copyblogger Media</p>
      </div>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Algoritma Esareti: Bugün Varsınız, Yarın?</h3>
      <p>Sosyal medya platformları, algoritmalarla çalışır. Gönderilerinizin kimlere, ne kadar gösterileceği sizin elinizde değildir. Bu algoritmalara bağımlı olduğunuzda, pazarlama stratejiniz platformların insafına kalır.</p>
      <p>Dahası, tüm trafiğiniz bu platformlarda kaldığında, müşteri verisini asla tam anlamıyla elde edemezsiniz. Ama bir web sitesi sayesinde;</p>
      <div class="space-y-4 my-10">
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 w-6 h-6 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center mt-0.5">
            <svg class="w-3.5 h-3.5 text-brand-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
          </div>
          <span class="text-gray-700 leading-relaxed">Ziyaretçi e-postaları toplayabilir,</span>
        </div>
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 w-6 h-6 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center mt-0.5">
            <svg class="w-3.5 h-3.5 text-brand-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
          </div>
          <span class="text-gray-700 leading-relaxed">Google Analytics ile kullanıcı davranışlarını anlayabilir,</span>
        </div>
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 w-6 h-6 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center mt-0.5">
            <svg class="w-3.5 h-3.5 text-brand-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
          </div>
          <span class="text-gray-700 leading-relaxed">Reklam stratejilerinizi buna göre şekillendirebilirsiniz.</span>
        </div>
      </div>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Marka Anlatımı İçin Sınırları Kaldırın</h3>
      <p>Sosyal medya, hızlı tüketim içindir. 15 saniyelik bir story ya da 2 satırlık bir gönderiyle markanızı anlatmak mümkün mü? Hayır. Ama bir web sitesi, sizi detaylarıyla, hikâyenizle, felsefenizle anlatabileceğiniz bir özgürlük alanı sunar. Kendi renk paletiniz, fontlarınız, navigasyonunuz… Hepsi marka kimliğinizin bir parçasıdır. Ve bu, sadece bir web sitesinde mümkündür.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Sosyal Medya ve Web Sitesi: Birlikte Güçlü</h3>
      <p>Yanlış anlaşılmasın: Sosyal medyayı küçümsemiyoruz. Ama yalnız başına yeterli olduğunu düşünmek, bir gemiyi sadece yelkenle yürütmeye çalışmak gibi. Motor, yani web sitesi olmadan dijital okyanusta rekabet etmeniz çok zor.</p>
      <div class="bg-gray-50 border-l-4 border-brand-blue p-6 my-8 rounded-r-lg shadow-sm">
        <p class="text-xl italic text-gray-800 font-medium mb-3">“Web siteleri markaların dijital merkezidir. Sosyal medya sadece bir trafik kaynağıdır.”</p>
        <p class="text-brand-blue font-bold not-italic">— Neil Patel, Dijital Pazarlama Uzmanı</p>
      </div>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Sonuç: Sahip Olduğunuz Alanı Büyütün</h3>
      <p>Sosyal medya bir başlangıç olabilir. Ama dijitalde kalıcı bir iz bırakmak istiyorsanız, o evi kurmalısınız. Bir web sitesi sadece bir adres değil, marka vizyonunuzun dışa vurumudur. Bugün küçük bir işletme bile, güçlü bir web sitesiyle global oyuncularla aynı sahnede yer alabilir.</p>
    `
  },
  {
    id: 5,
    slug: 'kucuk-isletmeler-icin-web-sitesi',
    title: 'Küçük İşletmeler İçin Web Sitesi Sahibi Olmanın Faydaları',
    excerpt: 'Büyük markalar bütçeyle yarışır, küçükler zekâyla kazanır. Web siteniz sizin 7/24 çalışan satış temsilcinizdir.',
    date: '03 Aralık 2025',
    image: blogImg2,
    category: 'KOBİ Dijitalleşme / Web Stratejileri',
    author: 'Pato Yazılım Ekibi',
    readTime: '3 dk',
    content: `

  <h3 class= "text-2xl font-bold text-brand-blue mt-8 mb-4" > Web Siteniz Sizin 7 / 24 Çalışan Satış Temsilcinizdir</h3>
      <p><strong>Büyük markalar bütçeyle yarışır, küçükler zekâyla kazanır.</strong></p>
      <p>Küçük işletmelerin en büyük sınavı, sınırlı kaynaklarla maksimum etki yaratmaktır. Peki, fiziksel bir mağazayı haftanın her günü, günde 24 saat açık tutmak mümkün mü? Hayır. Ama bir web sitesiyle bu mümkün.</p>
      <p>Web siteniz sizin adınıza çalışır, konuşur, ikna eder. Siz uykudayken potansiyel bir müşteri sitenize girip bilgi alabilir, ürünlerinizi inceleyebilir, hatta alışveriş yapabilir.</p>
      <div class="bg-gray-50 border-l-4 border-brand-blue p-6 my-8 rounded-r-lg shadow-sm">
        <p class="text-xl italic text-gray-800 font-medium mb-3">“Teknoloji yalnızca büyükler için değildir; doğru kullanıldığında, küçüklere kanat takar.”</p>
        <p class="text-brand-blue font-bold not-italic">— Steve Jobs</p>
      </div>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Arama Motorlarında Görünürlük = Yeni Müşteriler</h3>
      <p>Küçük bir işletmeyseniz, adınızı bilen kişi sayısı sınırlıdır. Ama Google sizi tanıyorsa, hiç tanımayanlar bile sizi bulur. İşte tam bu noktada SEO (Arama Motoru Optimizasyonu) devreye girer.</p>
      <p>Doğru anahtar kelimelerle yazılmış bir başlık, optimize edilmiş görseller, hızlı açılan bir sayfa… Bunlar sitenizi Google’ın üst sıralarına taşır. Örneğin bir “Moda Atölyesi” işletiyorsanız ve web sitenizde “kişiye özel dikim İstanbul” gibi optimize içerikler varsa, bu kelimeyi arayan biri sizi bulur. Ve en önemlisi: sadece bulmaz, size güvenir. Çünkü profesyonelce hazırlanmış bir web sitesi, kafalarda “Bu işin ehli” algısını oluşturur.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Ölçülebilirlik: Web Siteniz Size Ne Söylüyor?</h3>
      <p>Bir dükkâna her gün kaç kişinin girip çıktığını bilemeyebilirsiniz. Ama bir web sitesi, ziyaretçilerin nereden geldiğini, hangi sayfaları gezdiğini, nerede tıkladığını milimetrik şekilde ölçer. Google Analytics ve benzeri araçlar sayesinde müşteri davranışlarını anlamak mümkündür. İşte bu veri, size pazarlama stratejinizi şekillendirmek için altın değerinde içgörüler sunar.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Düşük Maliyetle Büyük Etki</h3>
      <p>Bir televizyon reklamı yüz binlerce lira… Gazete ilanı binlerce… Ama profesyonelce hazırlanmış bir web sitesi, bu bütçelerin çok küçük bir kısmıyla inşa edilebilir. Ve en önemlisi: Bu yatırım zamanla kendi kendini öder. Çünkü reklam bütçeniz olmasa bile arama motorları, sosyal medya bağlantıları ve içerikler üzerinden organik ziyaretçiler kazanmaya başlarsınız. Bu da sizin pazarlama yükünüzü hafifletir.</p>

      <p>Bir web sitesi, küçük bir işletmenin “küresel bir ciddiyet” kazanmasının yoludur. Girişimciler unutmasın: Artık başarı sadece ne sattığınızda değil, nasıl sunabildiğinizde saklıdır. Ve web sitesi bu sunumun ta kendisidir.</p>
    `
  },
  {
    id: 6,
    slug: 'web-sitesi-ile-musteri-guveni',
    title: 'Web Sitesi ile Müşteri Güveni Nasıl Artar?',
    excerpt: 'Güven, Görünürlükle Başlar. Bir marka ne kadar büyük olursa olsun, dijitalde görünmüyorsa bilinmiyor demektir.',
    date: '01 Aralık 2025',
    image: blogImg3,
    category: 'Kurumsal İtibar / Marka Yönetimi',
    author: 'Pato Yazılım Ekibi',
    readTime: '3 dk',
    content: `

  <h3 class= "text-2xl font-bold text-brand-blue mt-8 mb-4" > Güven, Görünürlükle Başlar</h3>
      <p>Bir marka ne kadar büyük olursa olsun, dijitalde görünmüyorsa bilinmiyor demektir. Hele küçük ve orta ölçekli işletmeler için bu görünürlük, olmak ya da olmamak meselesidir. İşte bu yüzden bir web sitesi sadece sizi anlatan bir broşür değil; karşı tarafa “Biz buradayız, güvenebilirsiniz” diyen bir vitrindir.</p>
      <p>İlk izlenim sadece saniyeler sürer. Ziyaretçi sitenize girdiğinde, tasarımın profesyonelliği, sayfaların yüklenme hızı, iletişim bilgilerinizin açıklığı ve içeriklerinizin doğruluğu onun bilinçaltında sizinle ilgili bir karar verir. Ve o karar, sizinle iletişime geçip geçmemesini belirler.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">“Resmi” Olmak, Güvenin Temelidir</h3>
      <p>Bir sosyal medya profili, bir sayfa olabilir; ama bir web sitesi, bir ofistir. Ve müşteriler, ofisi olan işletmelere daha çok güvenir. Çünkü bu, markanın yatırım yaptığını, ciddi olduğunu ve ulaşılabilir olduğunu gösterir. Özellikle web sitesinde açık adres bilgisi, sabit hat, harita entegrasyonu ve mail adresi gibi detaylar varsa, güven katlanır.</p>
      <p>Eğer bir SSL sertifikanız (yani sitenizde “https” varsa), yasal metinleriniz eksiksizse (gizlilik politikası, KVKK metni gibi), ziyaretçi kendini otomatik olarak güvende hisseder. İnternette güvenlik endişeleri büyüdükçe, bu tür görünmez detaylar altın değerinde olur.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">“İçerik” ile Güven İlişkisi Kurulur</h3>
      <p>Web sitesi bir nevi dijital danışmandır. Sadece “biz buyuz” demekle yetinmez, aynı zamanda bilgi verir. Blog yazıları, sık sorulan sorular, kullanım rehberleri ya da “biz kimiz” sayfası gibi içerikler, ziyaretçinin sizin uzmanlığınızı fark etmesini sağlar. Ve unutma: uzmanlık, güvenin en güçlü aracıdır.</p>
      <p>Bir müşteri aradığı bilgiyi sizin sitenizde buluyorsa, artık siz sadece bir hizmet sağlayıcı değil, bir rehbersiniz. Bu da satış yolculuğunda sizi diğerlerinden ayıran önemli bir farktır. İçerik üretmek zahmetli gibi görünse de, bu yatırımın geri dönüşü sadık müşterilerdir.</p>
    `
  },
  {
    id: 7,
    slug: 'restoranlar-icin-web-sitesi-ve-qr-menu-sistemlerinin-onemi',
    title: 'Restoranlar için Web Sitesi ve QR Menü Sistemlerinin Önemi',
    excerpt: 'Kafe ve restoranlar dijitalleşme sürecine nasıl ayak uydurmalı? Modern web siteleri ve QR menülerin işletmenize katacağı değerleri inceliyoruz.',
    date: '29 Kasım 2025',
    image: blogImg7,
    category: 'Restoran Teknolojileri / QR Menü',
    author: 'Pato Yazılım Ekibi',
    readTime: '3 dk',
    content: `
  <h3 class= "text-2xl font-bold text-brand-blue mt-8 mb-4" > Bir Tabak Yemeğin Arkasındaki Dijital Güç</h3>
      <p>Bir restoran yalnızca yemek sattığı bir yer değildir; bir deneyim sunar. Ve bu deneyim, günümüzde dijital dünyada başlar. Misafirleriniz sizi artık sokakta değil, Google’da arıyor. “En iyi kahvaltı yeri”, “yakınımdaki vegan restoran” ya da “romantik akşam yemeği mekanları” gibi aramalarda çıkmak istiyorsanız, profesyonel bir web sitenizin olması artık bir lüks değil, zorunluluk.</p>
      <p>Peki, neden sosyal medya hesabı yeterli değil? Çünkü web sitesi sizin resmi kimliğinizdir. Menü, rezervasyon, iletişim bilgileri ve galeri gibi içerikleri tek bir çatı altında toplayarak hem kullanıcı deneyimini iyileştirir, hem de sizi Google’ın gözünde ciddi bir marka olarak gösterir. Ayrıca algoritmalar sabah kahvesini Instagram’la değil, web sitenizle içmeyi tercih eder!</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">QR Menü ile Hijyenik, Hızlı ve Şık Deneyim</h3>
      <p>Pandemi sonrası hızla yükselen bir trend oldu, ancak QR menüler artık geçici bir çözüm değil. Temassız, hijyenik ve çevreci bir sistem olmasının yanı sıra, dinamik içerik yönetimi ile menünüzdeki değişiklikleri saniyeler içinde yansıtmanıza olanak tanır. Düşünün, artık menü bastırmak yok. Sezonluk tarif mi değişti? Fiyat mı güncellendi? Saniyeler içinde halledin.</p>
      <p>Üstelik QR menüler sadece kullanım kolaylığı sunmaz, aynı zamanda marka algınızı da modernleştirir. Mekânınızın ambiyansına uygun bir tasarımla entegre edilmiş QR sistem, müşteride “Bu yer işini biliyor” hissi uyandırır. Unutmayın, teknolojiye yatırım yapan restoran, müşterisinin zihninde bir adım öndedir.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Rezervasyon, Sipariş ve Daha Fazlası: Tüm Sistemler Entegre</h3>
      <p>Pato Yazılım olarak restoranlar için sunduğumuz web siteleri, sadece bilgilendirme amaçlı sayfalar değil; canlı sistemlerdir. Dilerseniz rezervasyon modülü, masa planı, sipariş sistemi ve ödeme altyapısı gibi detayları tek çatı altında entegre ediyoruz. Böylece kullanıcılarınız telefonla aramak zorunda kalmadan bir masa ayırtabilir, sipariş verebilir ya da etkinliklerinizi takip edebilir.</p>
      <p>Bu sistemler sadece müşteriyi memnun etmekle kalmaz, sizin operasyonel yükünüzü de azaltır. Daha az telefon trafiği, daha net siparişler ve daha iyi planlama. Dijitalleşme, yalnızca görünür olmak değil; daha verimli yönetmek demektir.</p>
    `
  },
  {
    id: 8,
    slug: 'neden-web-siteniz-olmali',
    title: 'Neden Web Siteniz Olmalı? Dijital Varlığın Temel Taşı',
    excerpt: 'İnternet çağında bir işletmenin web sitesi olmaması, kalabalık bir caddede dükkan açıp kepenkleri kapalı tutmaya benzer.',
    date: '27 Kasım 2025',
    image: blogImg5,
    category: 'Dijital Kimlik / Web Stratejileri',
    author: 'Pato Yazılım Ekibi',
    readTime: '4 dk',
    content: `
  <p> İnternet çağında bir işletmenin web sitesi olmaması, kalabalık bir caddede dükkan açıp kepenkleri kapalı tutmaya benzer.Sosyal medya profilleri gelip geçici olabilir ama web sitesi sizin dijital mülkünüzdür.İster küçük bir kafe olun ister bir yazılım devi, dijital varlığınızın temeli, size ait profesyonel bir web sitesiyle başlar.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Güvenilirliğin Dijital Kanıtı: Web Siteniz Sizi Temsil Eder</h3>
      <p>Bugünün tüketicisi araştırmadan adım atmıyor. Google’da adınızı aradığında karşısına çıkan ilk sonuç, kimliğinizi belirliyor. İşte burada profesyonel bir web sitesi devreye giriyor.</p>
      <p>Web siteniz, markanızın dijital vitrini gibidir. Estetik bir tasarım, düzenli içerikler, kolay erişim ve kurumsal bilgilerle dolu bir sayfa; müşterilerinizin gözünde sizi güvenilir ve güçlü bir marka haline getirir. SEO uyumlu sayfa yapısı, SSL sertifikası, mobil uyumluluk gibi teknik detaylar ise arama motorlarının sizi ön plana çıkarması için olmazsa olmazdır.</p>
      <p>Unutmayın, dijital dünyada güven önce görünürlükle başlar. Web siteniz yoksa, aslında yoksunuz.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Müşteriyle İlk Temas Noktası: 7/24 Açık, Otomatik ve Kontrol Sizde</h3>
      <p>Bir müşteri sabah 03:00’te bile sizi araştırmak isteyebilir. Sosyal medya algoritmaları, reklam bütçeleriyle oynayabilir; ama web siteniz sizin kontrolünüzde, her an açık bir satış temsilcinizdir.</p>
      <p>Ziyaretçileriniz sitenizde ürünlerinizi, hizmetlerinizi inceleyebilir, siz uyurken bile form doldurabilir ya da rezervasyon yapabilir. Üstelik doğru bir yapılandırmayla web siteniz sadece tanıtım aracı değil, bir otomasyon sistemine dönüşebilir: QR menüler, rezervasyon formları, e-posta pazarlama entegrasyonları, üyelik sistemleri, online ödeme altyapısı… Hepsi entegre edilebilir.</p>
      <p>Web siteniz sayesinde müşterilerinizi daha iyi tanır, davranışlarını analiz eder ve onlara özel stratejiler geliştirirsiniz.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Sadece Satış Değil, Marka Hikayeniz de Burada Yazılır</h3>
      <p>Bir web sitesi, sadece ürün satmak için değil, markanızı anlatmak için de güçlü bir sahnedir. Sosyal medya geçici ilgiler sunarken, web siteniz markanızın değerlerini, vizyonunu ve farkını uzun vadeli olarak sunar.</p>
      <p>Kurumsal kimliğiniz, referanslarınız, blog içerikleriniz, ekip tanıtımlarınız, basında çıkan haberleriniz ve müşteri yorumlarınız gibi içerikler; web sitenizi bir “hikâye anlatıcısına” dönüştürür. Ayrıca, SEO optimizasyonu sayesinde bu hikâye sadece mevcut müşterilerinize değil, potansiyel müşterilere de ulaşır.</p>

      <p>Web sitesi, dijital pazarlamada sadece bir araç değil, oyunun kurallarını değiştiren platformdur. Markanızı ciddiye alan herkesin ilk adımı: profesyonel bir web sitesi.</p>
      <p>Web sitesi, dijital dünyada görünür olmanın, güvenilir görünmenin ve satış potansiyelinizi artırmanın temelidir. Her gün web siteniz için geç kalan bir marka, potansiyel müşterilerini rakiplerine kaptırıyor olabilir. Siz o markalardan biri olmak zorunda değilsiniz. Başlamak için tek yapmanız gereken doğru ekiple çalışmak.</p>
      <p></p>
      <p>👉 <strong>Pato Yazılım ile tanışın, dijital sahnede yerinizi alın.</strong></p>
    `
  },
  {
    id: 1,
    slug: 'yapay-zeka-ve-is-dunyasinin-gelecegi-rekabetin-yeni-kodlari',
    title: 'Yapay Zeka ve İş Dünyasının Geleceği: Rekabetin Yeni Kodları',
    excerpt: 'Yapay zeka (AI) artık bir bilim kurgu unsuru değil, iş dünyasının kalbinde yer alan stratejik bir araç. Şirketler AI ile nasıl rekabet avantajı sağlar?',
    date: '23 Haziran 2025',
    image: blogImg6,
    category: 'Yapay Zeka Entegrasyonları / İş Dünyası',
    author: 'Pato Yazılım Ekibi',
    readTime: '5 dk',
    content: `
  <p> Yapay zeka(AI), günümüz iş dünyasında sadece bir teknoloji trendi olmaktan çıkıp, sürdürülebilir büyümenin ve rekabet avantajının temel yapı taşı haline geldi.Pato Yazılım olarak, AI teknolojilerini sadece bir yazılım eklentisi olarak değil; operasyonel verimliliği maksimize eden, maliyetleri minimize eden ve müşteri deneyimini yeniden tasarlayan bir mühendislik kaldıracı olarak görüyoruz.</p>
      <p>İşte yapay zekanın iş dünyasında yarattığı devrimin katmanları:</p>
      
      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Operasyonel Verimlilikte ve Süreçlerde Devrim</h3>
      <p>AI destekli otomasyon sistemleri, endüstri mühendisliğinin temel ilkesi olan "verimliliği" dijital dünyaya taşıyor. Tekrarlayan ve manuel efor gerektiren görevleri üstlenen algoritmalar, insan kaynağının daha stratejik ve yaratıcı alanlara odaklanmasını sağlıyor. Finans sektöründe fatura işleme, üretimde kalite kontrol veya lojistikte rota planlama gibi süreçler, AI sayesinde minimum hata payı ve maksimum hızla yönetiliyor.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Veri Odaklı Karar Alma: Sezgiden Analitiğe Geçiş</h3>
      <p>Büyük veri (Big Data) tek başına bir anlam ifade etmez; onu işleyen zeka önemlidir. Yapay zeka modelleri, geçmiş verileri analiz ederek işletmelere geleceğe yönelik stratejik öngörüler sunar. Satış tahminleri, stok optimizasyonu ve pazar trendleri gibi kritik konularda yöneticiler, artık belirsiz sezgilerine değil, algoritmaların sunduğu somut ve eyleme dönüştürülebilir analizlere güveniyor.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Hiper-Kişiselleştirilmiş Müşteri Deneyimi</h3>
      <p>Müşteri memnuniyeti artık standart hizmetle değil, kişiye özel deneyimle sağlanıyor. Doğal Dil İşleme (NLP) teknolojisiyle güçlendirilmiş chatbotlar ve sanal asistanlar, 7/24 kesintisiz ve empatik destek sunuyor. E-ticaret ve hizmet sektöründe kullanılan yapay zeka tabanlı öneri motorları ise, kullanıcının ne isteyeceğini ondan önce tahmin ederek satış oranlarını ve müşteri sadakatini ciddi ölçüde yükseltiyor.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Geleceğe Hazırlık: İnsan ve Makine Sinerjisi</h3>
      <p>Yapay zeka bir varış noktası değil, sürekli gelişen bir yolculuktur. Bu teknolojiye erken adapte olan ve süreçlerine entegre eden firmalar sektör liderliğine yükselirken, değişime direnenler rekabetin gerisinde kalma riski taşıyor. İş dünyasının geleceği; insan zekasının yaratıcılığı ile yapay zekanın işlem gücünün uyumlu işbirliğinde, yani bu dijital sinerjide yatıyor.</p>
`
  },
  {
    id: 2,
    slug: 'web-3-0-nedir',
    title: 'Web 3.0 Nedir? İnternetin Yeni Çağı',
    excerpt: 'Merkeziyetsiz internet kavramı ve blockchain teknolojisinin web deneyimine etkileri.',
    date: '04 Haziran 2025',
    image: blogImg7,
    category: 'Web 3.0 Teknolojileri / Gelecek',
    author: 'Pato Yazılım Ekibi',
    readTime: '4 dk',
    content: `
  <p> İnternet, tıpkı canlı bir organizma gibi sürekli evrim geçiriyor. 2018'den beri Pato Yazılım olarak, endüstri ve bilgisayar mühendisliği disiplinlerini birleştirdiğimiz projelerimizde bu değişimi yakından gözlemliyoruz. Bugün, internetin sadece "kullanıcısı" olduğumuz bir dönemden, "sahibi" olabileceğimiz yeni bir çağa; Web 3.0'a geçiş yapıyoruz.</p>
      <p>Peki, sıkça duyduğumuz bu kavram tam olarak ne anlama geliyor ve iş dünyasını nasıl değiştirecek? Mühendislik perspektifimizle Web 3.0'ın kodlarını çözüyoruz.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">İnternetin Kısa Tarihi: Oku, Yaz, Sahip Ol</h3>
      <p>Web 3.0'ı anlamak için önce nereden geldiğimize bakmak gerekir:</p>
      <div class="space-y-4 my-10">
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 w-6 h-6 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center mt-0.5">
            <svg class="w-3.5 h-3.5 text-brand-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
          </div>
          <span class="text-gray-700 leading-relaxed"><strong>Web 1.0 (1990-2004) - "Sadece Oku":</strong> İnternetin kütüphane dönemiydi. Statik web sayfaları vardı, kullanıcılar sadece bilgiye erişip okuyabiliyordu. Etkileşim neredeyse sıfırdı.</span>
        </div>
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 w-6 h-6 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center mt-0.5">
            <svg class="w-3.5 h-3.5 text-brand-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
          </div>
          <span class="text-gray-700 leading-relaxed"><strong>Web 2.0 (2004-Günümüz) - "Oku ve Yaz":</strong> Sosyal medyanın doğuşu. Kullanıcılar içerik üretmeye, yorum yapmaya ve paylaşmaya başladı. Ancak bir sorun vardı: Verilerimiz ve içeriklerimiz, merkezi dev şirketlerin (Big Tech) sunucularında tutuluyor ve yönetiliyordu. Ürün bizdik.</span>
        </div>
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 w-6 h-6 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center mt-0.5">
            <svg class="w-3.5 h-3.5 text-brand-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
          </div>
          <span class="text-gray-700 leading-relaxed"><strong>Web 3.0 (Gelecek) - "Oku, Yaz ve Sahip Ol":</strong> İşte kırılma noktası. Web 3.0, merkeziyetsizlik (decentralization) üzerine kuruludur. Verinin kontrolü şirketlerden alınıp, blokzincir (blockchain) teknolojisi sayesinde kullanıcılara geri verilir.</span>
        </div>
      </div>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Web 3.0'ın Temel Taşları</h3>
      <p>Pato Yazılım olarak, Web 3.0'ı sadece bir trend olarak değil, daha güvenli ve şeffaf süreçler tasarlamak için bir altyapı devrimi olarak görüyoruz. Bu yapıyı ayakta tutan üç ana sütun vardır:</p>
      <div class="space-y-4 my-10">
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 w-6 h-6 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center mt-0.5">
            <svg class="w-3.5 h-3.5 text-brand-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
          </div>
          <span class="text-gray-700 leading-relaxed"><strong>Merkeziyetsizlik:</strong> Veriler tek bir sunucuda değil, ağa dağılmış binlerce bilgisayarda saklanır. Bu, siber saldırılara karşı daha dirençli ve sansüre kapalı bir yapı oluşturur.</span>
        </div>
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 w-6 h-6 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center mt-0.5">
            <svg class="w-3.5 h-3.5 text-brand-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
          </div>
          <span class="text-gray-700 leading-relaxed"><strong>Blokzincir (Blockchain):</strong> Dijital varlıkların ve verilerin güvenli kaydını tutan defterdir. Web 3.0'da mülkiyetin kanıtı blokzincir üzerindedir.</span>
        </div>
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 w-6 h-6 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center mt-0.5">
            <svg class="w-3.5 h-3.5 text-brand-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
          </div>
          <span class="text-gray-700 leading-relaxed"><strong>Yapay Zeka ve Semantik Web:</strong> Web 3.0, verileri insanlar gibi "anlayabilen" makineler yaratmayı hedefler. Arama motorları ve yazılımlar, ne aradığınızı bağlamıyla birlikte daha iyi analiz eder.</span>
        </div>
      </div>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">İş Dünyası İçin Ne Değişecek?</h3>
      <p>Endüstri mühendisliği bakış açımızla süreçleri analiz ettiğimizde, Web 3.0'ın iş dünyasında verimliliği ve güveni yeniden tanımlayacağını görüyoruz:</p>
      <div class="space-y-4 my-10">
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 w-6 h-6 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center mt-0.5">
            <svg class="w-3.5 h-3.5 text-brand-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
          </div>
          <span class="text-gray-700 leading-relaxed"><strong>Aracıların Ortadan Kalkması:</strong> Akıllı sözleşmeler (Smart Contracts) sayesinde, noter veya banka gibi aracılara ihtiyaç duymadan güvenli ticaret ve anlaşmalar yapılabilecek.</span>
        </div>
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 w-6 h-6 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center mt-0.5">
            <svg class="w-3.5 h-3.5 text-brand-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
          </div>
          <span class="text-gray-700 leading-relaxed"><strong>Veri Güvenliği ve Gizlilik:</strong> Kullanıcılar kendi verilerinin sahibi olacak. Şirketler, devasa veri tabanlarını koruma yükünden ve siber güvenlik risklerinin bir kısmından kurtulabilecek.</span>
        </div>
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 w-6 h-6 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center mt-0.5">
            <svg class="w-3.5 h-3.5 text-brand-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
          </div>
          <span class="text-gray-700 leading-relaxed"><strong>Yeni İş Modelleri:</strong> Token ekonomisi ve NFT'ler, dijital mülkiyetin transferini ve sadakat programlarını tamamen değiştirecek.</span>
        </div>
      </div>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Pato Yazılım Perspektifi</h3>
      <p>Biz Pato Yazılım olarak, Web 3.0'a geçişi bir "kod güncellemesi"nden ziyade bir "zihniyet devrimi" olarak görüyoruz. Yazılım mimarilerimizi kurgularken, merkeziyetsizliğin getirdiği güvenlik avantajlarını ve yapay zekanın sunduğu analitik gücü projelerimize entegre etmeye odaklanıyoruz.</p>
      <p>Gelecek, verinin şeffaf olduğu, sistemlerin otonom çalıştığı ve güvenliğin mimarinin kendisi olduğu bir yer. Biz bu geleceği inşa etmeye hazırız.</p>
`
  },
  {
    id: 9,
    slug: 'siber-guvenlik-2025-trendleri',
    title: 'Siber Güvenlikte 2025 Trendleri: Dijital Kalenizi Geleceğe Hazırlayın',
    excerpt: 'Dijital dönüşümün hızı, sadece iş yapış şekillerimizi değil, risklerimizi de yeniden tanımlıyor. Güvenlik artık bir eklenti değil, yazılımın ta kendisidir.',
    date: '05 Aralık 2025',
    image: blogImg8,
    category: 'Siber Güvenlik',
    author: 'Pato Yazılım Ekibi',
    readTime: '5 dk',
    content: `
  <p> Dijital dönüşümün hızı, sadece iş yapış şekillerimizi değil, risklerimizi de yeniden tanımlıyor. 2018'den beri Pato Yazılım olarak, endüstri mühendisliğinin süreç odaklı bakış açısını bilgisayar mühendisliğinin teknik derinliğiyle birleştirerek projeler geliştiriyoruz. Gördüğümüz net bir tablo var:</p>

    <div class="bg-gray-50 border-l-4 border-brand-blue p-6 my-8 rounded-r-lg shadow-sm" >
        <p class="text-xl italic text-gray-800 font-medium mb-3">“Güvenlik artık bir 'eklenti' değil, yazılımın ta kendisidir.”</p>
        <p class="text-brand-blue font-bold not-italic">— Pato Yazılım</p>
      </div>

      <br><p>2025 yılına yaklaşırken, siber tehditlerin şekil değiştirdiğini ve savunma stratejilerinin de buna paralel olarak evrimleşmesi gerektiğini görüyoruz. İşte Pato Yazılım perspektifiyle, önümüzdeki yılın en kritik siber güvenlik trendleri ve hazırlıklı olmanız gereken noktalar.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">1. Yapay Zeka: Hem Kalkan Hem Kılıç</h3>
      <p>Yapay zeka (AI), siber güvenlikte çift ucu keskin bir bıçak haline geldi. 2025'te saldırganlar, daha karmaşık kimlik avı (phishing) e-postaları hazırlamak ve savunma duvarlarını aşan otonom kötü amaçlı yazılımlar üretmek için AI kullanacak.</p>
      <p>Buna karşılık, savunma tarafında biz mühendisler de AI'dan güç alıyoruz. Anomali tespiti yapan, tehditleri insan müdahalesi olmadan saniyeler içinde fark edip izole eden yapay zeka destekli güvenlik protokolleri, yeni standardımız oluyor.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">2. Kuantum Sonrası Kriptografi (PQC)</h3>
      <p>Kuantum bilgisayarların yükselişi, mevcut şifreleme yöntemlerini (bugün bankaların bile kullandığı yöntemleri) tehdit etmeye başlıyor. 2025, "Şimdi topla, sonra şifresini çöz" (Harvest Now, Decrypt Later) stratejisine karşı bir dönüm noktası olacak.</p>
      <p>Verilerinizi gelecekteki bu tehditten korumak için, kuantum saldırılarına dirençli yeni şifreleme algoritmalarına geçiş, yazılım mimarisinin temel taşlarından biri haline geliyor.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">3. İnsan Güvenlik Duvarı ve "Deepfake" Tehdidi</h3>
      <p>Teknoloji ne kadar gelişirse gelişsin, insan faktörü hala en kritik halka. Ancak tehdit artık sadece "şüpheli bir linke tıklamak" değil. Ses ve görüntü klonlama teknolojileri (Deepfake) ile CEO dolandırıcılığı (CEO Fraud) ve kimlik hırsızlığı vakalarında artış bekleniyor.</p>
      <p>2025'te güvenlik, sadece yazılımsal değil, personelin bu yeni nesil manipülasyonlara karşı eğitilmesini de kapsayan bütünsel bir süreç yönetimi gerektiriyor. Endüstri mühendisliği disiplinimiz tam burada devreye giriyor: Süreci insan hatasını minimize edecek şekilde tasarlamak.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">4. Sıfır Güven (Zero Trust) Mimarisi 2.0</h3>
      <p>“Güven ama doğrula” devri kapandı. Artık parola:</p>

      <div class="bg-gray-50 border-l-4 border-brand-blue p-6 my-8 rounded-r-lg shadow-sm">
        <p class="text-xl italic text-gray-800 font-medium mb-3">“Asla güvenme, her zaman doğrula.”</p>
      </div>

      <br><p>Sıfır Güven mimarisi, ağın içindeki veya dışındaki hiçbir kullanıcıya veya cihaza varsayılan olarak güvenilmediği bir yaklaşımdır. 2025 trendlerinde bu yaklaşım, sadece kurumsal ağlarda değil, geliştirdiğimiz her bir SaaS uygulamasında ve mikro servis mimarisinde standart hale geliyor. Kimlik doğrulama, sürekli ve dinamik bir süreç olmalı.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">5. Tedarik Zinciri Güvenliği</h3>
      <p>Kendi kaleniz sağlam olabilir, peki ya tedarikçileriniz? Saldırganlar artık ana hedefi doğrudan vurmak yerine, o hedefe hizmet veren daha küçük yazılım sağlayıcılarını hedef alıyor.</p>
      <p>Yazılım geliştirme sürecinde kullandığımız kütüphanelerden, üçüncü taraf entegrasyonlara kadar her bileşenin güvenliği hayati önem taşıyor. Pato Yazılım olarak, "işi kendi işimiz gibi sahiplenme" prensibimiz gereği, sadece kendi kodumuzun değil, ekosistemimizdeki her bileşenin güvenliğini titizlikle denetliyoruz.</p>

      <h3 class="text-2xl font-bold text-brand-blue mt-8 mb-4">Sonuç: Pato Yazılım ile Güvenli Gelecek</h3>
      <p>2025'in siber güvenlik manzarası korkutucu görünebilir, ancak doğru mühendislik yaklaşımıyla yönetilebilir risklerdir. Biz, projelerimizi geliştirirken güvenliği "sonradan eklenen bir özellik" olarak değil, projenin "DNA'sı" olarak görüyoruz.</p>
      <p>Dijital varlıklarınızı geleceğin tehditlerine karşı bugünden hazırlamak ve güvenli yazılım çözümleriyle tanışmak için Pato Yazılım ekibiyle iletişime geçebilirsiniz.</p>
`
  },

];

export const FAQS: FaqItem[] = [
  {
    question: 'Pato Yazılım hangi hizmetleri sunar?',
    answer: 'Pato Yazılım; kurumsal web altyapıları, e-ticaret sistemleri ve yapay zeka otomasyonları alanında hizmet veren bir dijital ajanstır. Ek olarak SEO (Arama Motoru Optimizasyonu), mobil uygulama geliştirme ve IT danışmanlığı süreçlerini de profesyonel şekilde yönetiyoruz.'
  },
  {
    question: 'Avukat web sitesi nasıl olmalı?',
    answer: 'Bir avukat web sitesi; sade, güven veren ve doğrudan kullanıcının hukuki arayışına net cevap sunan bir bilgi merkezi olmalıdır. Pato Yazılım olarak hukuk bürolarına özel geliştirdiğimiz web sitelerinde hızlı açılış süreleri, SSS (Sıkça Sorulan Sorular) yapıları ve AEO (Cevap Motoru Optimizasyonu) standartları uyguluyoruz.'
  },
  {
    question: 'İçerik yönetim paneli (CMS) nedir?',
    answer: 'İçerik yönetim paneli (CMS); hiçbir kod veya teknik bilgiye ihtiyaç duymadan, web sitenizdeki yazıları, görselleri ve sayfaları kendinizin güncelleyebilmesini sağlayan bir sistemdir. Geliştirdiğimiz özel paneller sayesinde sadece saniyeler içinde yeni duyurular yayınlayabilir veya mevcut hizmetlerinizi değiştirebilirsiniz.'
  },
  {
    question: 'Web sitenizin mobil uyumu (responsive tasarımı) var mı?',
    answer: 'Evet, tüm projelerimiz %100 mobil uyumlu (responsive) olarak tasarlanır. Ziyaretçileriniz akıllı telefon, tablet veya masaüstü bilgisayardan bağlandıklarında ekran boyutlarına göre kendini otomatik ayarlayan, hızlı ve kusursuz bir deneyim yaşarlar.'
  },
  {
    question: 'Arama motoru optimizasyonu (SEO) hizmeti veriyor musunuz?',
    answer: 'Evet, tüm web projelerimizi teknik SEO standartlarına uygun şekilde kodluyoruz. Ayrıca organik aramalarda daha yüksek sıralara ulaşmanız için anahtar kelime araştırması, site hızı optimizasyonları ve semantik veri (JSON-LD) işaretlemeleri de uyguluyoruz.'
  },
  {
    question: 'Proje teslim süreleri ortalama ne kadar sürer?',
    answer: 'Ortalama bir kurumsal web sitesi projesi 2-4 hafta içinde tamamlanmaktadır. E-ticaret platformları veya gelişmiş mobil uygulamalar ise projenin gereksinimlerine göre 6-12 haftalık detaylı bir çalışma takvimi gerektirebilir.'
  },
  {
    question: 'Sitemin yapay zeka arama motorlarında (ChatGPT, Perplexity) kaynak gösterilmesi için ne yapıyorsunuz?',
    answer: 'Arama motorlarının geleceği olan Üretken Motor Optimizasyonu (GEO) standartlarını tüm projelerimizde uyguluyoruz. Sitenizin arka planına eklediğimiz semantik veri işaretlemeleri (JSON-LD) ve makine okumasına uygun yapılandırılmış dosyalar sayesinde, yapay zeka asistanlarının markanızı net bir şekilde anlayıp kullanıcılara "doğrulanmış kaynak" olarak sunmasını sağlıyoruz.'
  },
  {
    question: 'Web siteme yapay zeka (AI) özellikleri entegre edilebilir mi?',
    answer: 'Kesinlikle. Pato Yazılım olarak kurumsal web projelerinize; 7/24 kesintisiz destek sağlayan akıllı sohbet botları (AI Chatbot), site içi arama niyetini anlayan akıllı arama modülleri ve verilerinizi analiz eden yönetici raporlama asistanları gibi ileri düzey yapay zeka çözümleri entegre edebiliyoruz.'
  },
  {
    question: 'Hazır e-ticaret paketleri yerine neden özel e-ticaret yazılımı tercih etmeliyim?',
    answer: 'Hazır e-ticaret paketleri, markanızı birbirini tekrar eden şablonlara ve kısıtlayıcı sınırlara mecbur bırakır. Pato Yazılım tarafından özel geliştirilen e-ticaret altyapıları ise markanızın kimliğine %100 uyum sağlar, milisaniyeler içinde açılarak sepet terk etme oranlarını düşürür ve işletmeniz büyüdükçe hiçbir altyapı engeline takılmadan esnek bir şekilde ölçeklenir.'
  },
  {
    question: 'Kullandığım CRM veya muhasebe programını web siteme bağlayabilir misiniz?',
    answer: 'Evet, API (Uygulama Programlama Arayüzü) altyapısına sahip olan tüm harici yazılımları web sistemlerinize entegre edebiliyoruz. Böylece web sitenizden gelen müşteri talepleri doğrudan CRM panelinize düşebilir veya e-ticaret sitenizdeki stok-fiyat bilgileri muhasebe programınızla eşzamanlı olarak çalışabilir.'
  },
  {
    question: 'Web sitemin ve müşteri verilerimin güvenliği nasıl sağlanıyor?',
    answer: 'Geleneksel açık kaynaklı sistemlerin kronik güvenlik açıklarından uzak, modern ve izole bir yazılım mimarisi kurguluyoruz. Veritabanı iletişimlerinde uçtan uca şifreleme, gelişmiş kimlik doğrulama sistemleri ve güvenli bulut sunucu yapılandırmaları kullanarak kurumsal verilerinizi ve müşteri gizliliğinizi en üst düzeyde koruma altına alıyoruz.'
  },
  {
    question: 'Proje yayına girdikten sonra teknik destek ve bakım hizmeti sunuyor musunuz?',
    answer: 'Evet, dijital ofisinizin her an kusursuz çalışması bizim önceliğimizdir. Proje tesliminin ardından; sunucu sağlığı izleme, düzenli yedekleme, sistem güncellemeleri ve olası geliştirme talepleriniz için profesyonel teknik destek anlaşmaları (SLA) ile çözüm ortağınız olmaya devam ediyoruz.'
  }
];

export const PRICING_FAQS: FaqItem[] = [
  {
    question: 'Web sitesi fiyatlarına alan adı (domain) ve sunucu (hosting) ücretleri dahil mi?',
    answer: 'Hayır, alan adı (domain) ve sunucu (hosting) hizmetleri ile yasal vergiler (KDV) tabloda belirtilen paket fiyatlarına dahil değildir. Bu hizmetler, projenizin trafik hacmine ve altyapı ihtiyacına göre tamamen sizin adınıza ve size ait olacak şekilde ayrıca projelendirilmektedir.'
  },
  {
    question: 'Seçtiğim paketteki sayfa sayısını aşarsam ek ücret öder miyim?',
    answer: 'Evet, paketlerimizde belirtilen standart sayfa sayılarının (örneğin Detaylı Web Sitesi için 3 sayfa) üzerine çıkmak isterseniz, eklenen her yeni sayfa için 2.500₺ ek sayfa bedeli yansıtılmaktadır. Bu sayede sadece ihtiyacınız olan sayfa sayısı kadar ödeme yaparsınız.'
  },
  {
    question: 'Fiyatların yanında neden "başlayan fiyatlar" ibaresi yer alıyor?',
    answer: 'Tabloda belirtilen rakamlar, ilgili paketin temel standartlarını kapsayan taban fiyatlardır. Projenize özel çoklu dil seçeneği (TR/EN), gelişmiş animasyonlar veya harici bir CRM/Muhasebe entegrasyonu gibi ek mühendislik talepleriniz olması durumunda fiyatlandırma projenin kapsamına göre güncellenir.'
  },
  {
    question: '"Size Özel Web Sitesi" paketinin fiyatı nasıl belirleniyor?',
    answer: 'Size Özel Web Sitesi; e-ticaret altyapıları, online rezervasyon sistemleri, üye yönetim panelleri ve özel logo tasarımı gibi ileri düzey gereksinimleri kapsar. Bu paketin fiyatı, markanızın hedefleri doğrultusunda yapacağımız teknik analiz toplantısının ardından ihtiyaç duyulan yazılım mimarisine göre özel olarak hesaplanmaktadır.'
  },
  {
    question: 'Web sitem teslim edildikten sonra yıllık ödemem gereken başka ücretler var mı?',
    answer: 'Pato Yazılım’a web sitesi tasarımı ve kodlaması için sadece bir kez ödeme yaparsınız. Ancak web sitenizin yayında kalabilmesi için alan adı (domain) ve sunucu (hosting) firmalarına yıllık standart yenileme ücretleri ödemeniz gerekmektedir.'
  },
  {
    question: 'Yapay zeka destekli görseller ve içerikler ne anlama geliyor?',
    answer: 'Temel ve Detaylı paketlerimizde, sitenizin metinleri ve görselleri markanızın sektörüne uygun olarak profesyonel yapay zeka araçları ile optimize edilerek üretilir. Böylece siteniz hem arama motorlarına uygun (SEO dostu) hem de görsel açıdan modern bir bütünlüğe sahip olur.'
  }
];

export const MOBILE_APP_FAQS: FaqItem[] = [
  {
    question: 'Uygulama marketleri (App Store ve Google Play) geliştirici hesap ücretleri fiyatlara dahil mi?',
    answer: 'Hayır, Apple ve Google tarafından talep edilen geliştirici platform ücretleri müşterilerimize aittir. Pato Yazılım olarak biz, uygulamanızın kodlanmasını ve bu platformlara eksiksiz, kurallara uygun bir şekilde yüklenmesi sürecini (teknik onay süreçleri dahil) profesyonelce yönetiyoruz.'
  },
  {
    question: 'Neden React Native veya Flutter teknolojilerini kullanıyorsunuz?',
    answer: 'Bu teknolojiler "çapraz platform" (cross-platform) mimarisine sahip en ileri düzey yazılım çerçeveleridir. Yani tek bir kod tabanı yazılarak hem iOS hem de Android cihazlarda yerel (native) hızında, kusursuz ve yüksek performanslı çalışan uygulamalar elde ederiz. Bu durum kurumsal projelerinizin pazara çıkış süresini kısaltır ve bakım maliyetlerini optimize eder.'
  },
  {
    question: 'Başlangıç paketindeki 4 sayfa sınırını aşarsam ne olur?',
    answer: 'Başlangıç paketimiz, fikrini hızlıca pazara sunmak isteyen küçük işletmeler ve MVP (Minimum Uygulanabilir Ürün) projeleri için optimize edilmiştir. Eğer uygulamanızda 4 ekrandan daha fazlasına ihtiyacınız olursa, tasarlanacak ve kodlanacak her yeni sayfa için 5.000₺ ek hizmet bedeli yansıtılmaktadır.'
  },
  {
    question: 'Gelişmiş Paket için özel fiyat teklifi süreci nasıl işliyor?',
    answer: 'Gelişmiş ve kapsamlı mobil projelerinizde öncelikle ihtiyaçlarınızı dinliyoruz. Eklenecek ödeme, harita, rezervasyon gibi modüller, projenin büyüklüğü ve teslim süresi analiz edildikten sonra, ilk görüşmemizden itibaren en geç 5 iş günü içerisinde size özel mimari planımızı ve net fiyat teklifimizi sunuyoruz.'
  }
];

export const ENTERPRISE_FAQS: FaqItem[] = [
  {
    question: 'IT Danışmanlık ve Özel Yazılım hizmetlerinde neden sabit bir fiyat tablosu yok?',
    answer: 'Özel yazılımlar, bulut mimarileri veya CRM/ERP otomasyonları her şirketin kendi iç dinamiklerine ve veri hacmine göre benzersizdir. Mevcut teknolojik altyapınızın detaylı bir sistem analizi yapılmadan verilecek fiyatlar yanıltıcı olacağından, bu projeleri tamamen kurumunuzun ihtiyaçlarına (terzi işi) göre özel olarak fiyatlandırıyoruz.'
  },
  {
    question: 'Geliştireceğiniz özel yazılım, halihazırda kullandığımız muhasebe veya stok programıyla çalışır mı?',
    answer: 'Kesinlikle. İleri düzey yazılım mühendisliği yaklaşımlarımız ve API (Uygulama Programlama Arayüzü) entegrasyonlarımız sayesinde, şirketinizin yıllardır kullandığı eski sistemleri yeni kurgulayacağımız özel yazılımlarla veya raporlama panelleriyle sorunsuz bir şekilde konuşturabiliyoruz.'
  },
  {
    question: 'Veri Analizi ve İş Zekası (BI) hizmetlerinde şirket verilerimizin güvenliği nasıl sağlanıyor?',
    answer: 'Kurumsal verileriniz, KVKK (Kişisel Verilerin Korunması Kanunu) ve uluslararası veri güvenliği standartlarına (ISO 27001) tam uyumlu, şifrelenmiş özel bulut sunucularda işlenir. Pato Yazılım olarak şirketinizin ticari sırlarını en üst düzey siber güvenlik protokolleriyle izole ediyor ve koruyoruz.'
  },
  {
    question: 'Mevcut teknolojik altyapı analizini (IT Check-up) nasıl yapıyorsunuz?',
    answer: 'Öncelikle sunucu altyapınızı, yazılım mimarilerinizi, güvenlik açıklarınızı ve personelinizin yazılım kullanım alışkanlıklarını denetliyoruz. Ardından kurumunuzun dijital dönüşümde nerede olduğunu, darboğazları ve maliyet optimizasyonu yapılabilecek noktaları detaylı bir mühendislik raporu halinde yönetiminize sunuyoruz.'
  }
];

export const TEAM_MEMBERS: TeamMember[] = [
  {
    id: 1,
    name: 'Ceren Tekin Bilgin',
    role: 'Co-Founder',
    image: '/images/ceren.webp',
    linkedin: 'https://www.linkedin.com/in/cerentekin/'
  },
  {
    id: 2,
    name: 'Ahmet Bilgin',
    role: 'Co-Founder',
    image: '/images/ahmet.webp',
    linkedin: 'https://www.linkedin.com/in/ahmetbilgin/'
  }
];

export const PROJECTS: Project[] = [
  {
    id: 11,
    slug: 'engblaw',
    title: 'ENGB Law & Partners',
    category: 'Web Geliştirme',
    image: '/images/engblaw-1.webp',
    description: 'Global vizyona sahip hukuk büroları için geliştirdiğimiz; avukatların hiçbir kod bilgisine ihtiyaç duymadan kendi içeriklerini güncelleyebildiği, çok dilli modern web platformu.',
    client: 'ENGB Law & Partners',
    year: '2026',
    technologies: ['PHP', 'MySQL İlişkisel Veri Modeli', 'Responsive Grid System', 'Asenkron JS / Optimize CSS', 'WebMCP Protokol Şemaları', 'llms.txt / llms-full.txt Dynamic Routing', 'Hreflang Language Mapping', 'X-Robots-Tag Security'],
    challenge: 'Uluslararası arenada hizmet veren ENGB Law & Partners projesindeki temel hedefimiz; büronun kapsamlı ve çok dilli (TR/EN) kurumsal verilerini tek bir merkezden, esnekçe yönetebileceği bir altyapı kurmaktı. Bu süreçteki en büyük vizyonumuz; her iki dildeki makaleleri, faaliyet alanlarını ve uzman profillerini global arama motorlarında kusursuz bir şekilde eşleştirmek ve platformu yeni nesil yapay zeka asistanlarına doğrudan anlamlı veri sunabilecek bir olgunluğa taşımaktı.',
    solution: 'Pato Yazılım olarak bu hedeflere, büronun global iş akışına tam uyum sağlayan özel bir Kurumsal Yönetim Paneli (CMS) kurgulayarak yanıt verdik. Geliştirdiğimiz bu esnek mimari sayesinde ofis ekibi; uzman kadro, sektörler, makaleler ve işbirlikleri gibi tüm içerikleri hiçbir kod bilgisine ihtiyaç duymadan özgürce yönetebilir hale geldi. Ön yüz tarafında ise hız odaklı bir strateji izleyerek, dünyanın neresinden girilirse girilsin sıfıra yakın gecikmeyle açılan ve pürüzsüz çalışan bir dijital deneyim inşa ettik.',
    result: 'Geleneksel arama motoru optimizasyonunun (SEO) ötesine geçerek, platformu en güncel "Yapay Zeka Uyumlu" standartlarla donattık. Sitenin tüm içerik ağacını, yapay zeka botlarının (OpenAI, Google, Anthropic) kolayca okuyup anlayabileceği şekilde, dillere göre gruplanmış ve özetlenmiş özel bir formata çevirdik. Bu yenilikçi altyapı sayesinde ENGB Law projesi; Perplexity, SearchGPT ve Gemini gibi yeni nesil akıllı arama motorlarında doğrudan kaynak gösterilme kabiliyeti kazanarak küresel görünürlüğünü dijitalin en ileri seviyesine taşıdı.',
    images: [
      '/images/engblaw-1.webp',
      '/images/engblaw-2.webp',
      '/images/engblaw-3.webp',
      '/images/engblaw-4.webp',
      '/images/engblaw-5.webp',
      '/images/engblaw-6.webp'
    ],
    link: 'https://engblaw.com'
  },
  {
    id: 10,
    slug: 'dabhukuk',
    title: 'DAB Hukuk',
    category: 'Web Geliştirme',
    image: '/images/dabhukuk-1.webp',
    description: 'Avukatların hukuki makalelerini ve uzmanlık alanlarını özel bir panel üzerinden kolayca yayınlayabildiği yüksek hızlı kurumsal hukuk sitesi.',
    client: 'DAB Hukuk',
    year: '2026',
    technologies: ['PHP', 'Gelişmiş PDO Veri Tabanı Optimizasyonu', 'MySQL', 'Accessibility Tree Architecture (Erişilebilirlik Ağacı)', 'Aria-Label Framework', 'WebP Image Encoding', 'WebMCP Tool Registry Semantics', 'JSON-LD Form Schemas', 'Dynamic Automated llms-full.txt Indexing'],
    challenge: "DAB Hukuk Bürosu'nun dijital dönüşüm sürecindeki temel amaç; büronun sürekli genişleyen hukuki makale kütüphanesini, uzman kadrosunu ve faaliyet alanlarını müvekkillere pürüzsüz bir kullanıcı deneyimiyle (UX) sunmaktı. Projedeki en büyük hedefimiz; sitenin tüm cihazlarda maksimum hızda açılmasını sağlamak, ofis ekibine siteyi tek tıkla yönetebilecekleri bir sistem sunmak ve platformu yeni nesil yapay zeka arama motorlarına %100 uyumlu hale getirmekti.",
    solution: "Pato Yazılım olarak bu hedeflere, hazır şablonlardan tamamen bağımsız, DAB Hukuk’a özel bir İçerik Yönetim Paneli (CMS) geliştirerek yanıt verdik. Kurduğumuz bu kullanıcı dostu yazılım sayesinde avukatlar; hiçbir teknik destek almadan yeni makaleler yayınlayabiliyor, uzmanlık alanlarını birbiriyle ilişkilendirebiliyor ve yasal metinleri tek bir ekrandan kolayca güncelleyebiliyor. Arka planda kurguladığımız modern mimariyle sistemi olabildiğince hafiflettik ve geniş arşive rağmen hem masaüstü hem de mobil cihazlarda kesintisiz, ultra hızlı bir gezinme performansı yarattık.",
    result: "Geleneksel web standartlarının ötesine geçerek, sitenin altyapısını yapay zeka asistanlarının kolayca anlayabileceği bir dijital olgunluğa ulaştırdık. Geliştirdiğimiz erişilebilirlik ve form şemaları sayesinde; akıllı yapay zeka botları sitedeki iletişim formlarını güvenle okuyabilir, makale özetlerini indeksleyebilir hale geldi. Sonuç olarak DAB Hukuk; sadece bugünün değil, yarının \"Yapay Zeka Tabanlı\" aramalarında da organik görünürlüğünü zirveye taşıyacak premium bir dijital ofise kavuştu.",
    images: [
      '/images/dabhukuk-1.webp',
      '/images/dabhukuk-2.webp',
      '/images/dabhukuk-3.webp',
      '/images/dabhukuk-4.webp',
      '/images/dabhukuk-5.webp',
      '/images/dabhukuk-6.webp'
    ],
    link: 'https://dabhukuk.av.tr'
  },
  {
    id: 7,
    slug: 'corexbomontistudio',
    title: 'Corex Bomonti Studio',
    category: 'Web Geliştirme',
    image: '/images/websitesi-corexbomonti.webp',
    description: 'Corex Bomonti Studio için geliştirilen, üyelik ve rezervasyon yönetimini dijitalleştiren kapsamlı web platformu.',
    client: 'Corex Bomonti Studio',
    year: '2025',
    technologies: ['PHP', 'Javascript', 'MySQL', 'SEO'],
    challenge: 'Stüdyonun üyelik takibi, ders rezervasyonları ve kredi yönetimi gibi karmaşık operasyonel süreçlerini tek bir merkezden yönetilebilir hale getirmek ve "Bomonti Pilates" aramalarında görünürlüğü artırmak.',
    solution: 'Giriş paneli, detaylı üyelik yönetimi, ders rezervasyon sistemi, kredi tanımlama/takip modülü, takvim yönetimi ve üye ölçüm yükleme özelliklerine sahip özel bir web yazılımı geliştirdik. SEO odaklı içerik yapısıyla arama motoru performansını optimize ettik.',
    result: 'Tüm stüdyo operasyonları dijitalleşerek verimlilik arttı. "Bomonti Pilates" ve ilgili aramalarda üst sıralara yükselerek marka bilinirliği ve yeni üye kazanımı sağlandı.',
    images: [
      '/images/websitesi-corexbomonti.webp',
      '/images/websitesi-corexbomonti2.webp',
      '/images/websitesi-corexbomonti3.webp'
    ],
    link: 'https://www.corexbomonti.com'
  },
  {
    id: 8,
    slug: 'mhdizayn',
    title: 'MH Dizayn Mobilya & Dekorasyon',
    category: 'Web Geliştirme',
    image: '/images/websitesi-mhdizayn.webp',
    description: 'MH Dizayn Mobilya & Dekorasyon için geliştirilen, marka tanıtımı ve proje sergileme odaklı kurumsal web sitesi.',
    client: 'MH Dizayn Mobilya & Dekorasyon',
    year: '2025',
    technologies: ['PHP', 'Javascript', 'MySQL', 'SEO'],
    challenge: 'Mobilya ve dekorasyon sektöründe rekabetin yoğun olduğu bir ortamda, markanın projelerini etkileyici bir şekilde sunmak ve potansiyel müşterilere hızlıca ulaşmak.',
    solution: 'Modern ve şık bir arayüz ile marka tanıtımı, proje galerileri ve blog altyapısı oluşturuldu. WhatsApp entegrasyonu ile hızlı iletişim sağlandı ve güçlü SEO çalışmalarıyla arama motoru görünürlüğü artırıldı.',
    result: 'Markanın dijital vitrini güçlendi, müşteri etkileşimleri arttı ve SEO uyumlu yapı sayesinde organik trafikte artış sağlandı.',
    images: [
      '/images/websitesi-mhdizayn.webp',
      '/images/websitesi-mhdizayn2.webp',
      '/images/websitesi-mhdizayn3.webp'
    ],
    link: 'https://www.mhdizayn.com'
  },
  {
    id: 9,
    slug: 'lldhukuk',
    title: 'LLD Hukuk & Danışmanlık',
    category: 'Web Geliştirme',
    image: '/images/websitesi-lldhukuk.webp',
    description: 'LLD Hukuk için geliştirilen, kurumsal kimliği yansıtan ve hukuki makalelerle bilgi paylaşımı sağlayan web platformu.',
    client: 'LLD Hukuk',
    year: '2025',
    technologies: ['PHP', 'Javascript', 'MySQL', 'SEO'],
    challenge: 'Hukuk bürosunun uzmanlık alanlarını ve makalelerini etkili bir şekilde sunarak, arama motorlarında görünürlüğü artırmak ve potansiyel müvekkillere güven vermek.',
    solution: 'Kullanıcı dostu bir arayüz ile makale yönetim sistemi, uzmanlık alanları tanıtımı ve iletişim modülleri geliştirildi. SEO uyumlu içerik yapısı ile hukuki aramalarda üst sıralarda yer alması sağlandı.',
    result: 'Hukuk bürosunun dijital varlığı güçlendi, makaleler sayesinde organik trafik arttı ve potansiyel müvekkil etkileşimleri yükseldi.',
    images: [
      '/images/websitesi-lldhukuk.webp',
      '/images/websitesi-lldhukuk2.webp',
      '/images/websitesi-lldhukuk3.webp'
    ],
    link: 'https://www.lldhukuk.av.tr'
  }
];

export const DEMO_SITES: DemoSite[] = [
  {
    id: 'avukat',
    title: 'Avukat & Hukuk Bürosu',
    category: 'Kurumsal',
    description: 'Hukuk büroları için özel tasarlanmış, makale (içtihat) yayınlama ve randevu modüllü kurumsal web sitesi.',
    url: 'https://avukat.patoyazilim.com',
    image: '/images/demo-avukat.webp',
    features: ['Blog & Makale Modülü', 'SEO Uyumlu Hizmet Sayfaları', 'WhatsApp Entegrasyonu', 'Hızlı Yükleme']
  },
  {
    id: 'dis-hekimi',
    title: 'Diş Hekimi & Klinik',
    category: 'Kurumsal',
    description: 'Diş hekimleri ve klinikler için online randevu altyapılı, tedavi öncesi/sonrası galerili modern web sitesi.',
    url: 'https://dis-hekimi.patoyazilim.com',
    image: '/images/demo-dis-hekimi.webp',
    features: ['Online Randevu', 'Öncesi/Sonrası Galeri', 'Tedavi Hizmetleri Modülü', 'Harita Entegrasyonu']
  },
  {
    id: 'yonetim-paneli',
    title: 'Kurumsal Yönetim Paneli',
    category: 'Özel Yazılım',
    description: 'İşletmelerin içeriklerini, ürünlerini ve iletişim formlarını tek noktadan kolayca yönetebildiği özel admin paneli.',
    url: 'https://panel.patoyazilim.com',
    image: '/images/demo-panel.webp',
    features: ['Dinamik İçerik Yönetimi', 'Kullanıcı Yetkilendirme', 'Grafikli Raporlama', 'Form Takibi']
  },
  {
    id: 'e-ticaret',
    title: 'Modern E-Ticaret',
    category: 'E-Ticaret',
    description: 'Sanal pos entegrasyonlu, hızlı ve dönüşüm odaklı (Conversion Optimized) B2C e-ticaret platformu.',
    url: 'https://eticaret.patoyazilim.com',
    image: '/images/demo-eticaret.webp',
    features: ['Iyzico/Stripe Ödeme Altyapısı', 'Gelişmiş Varyant Sistemi', 'Sipariş Yönetimi', 'Sepet Hatırlatma']
  },
  {
    id: 'psikolog',
    title: 'Psikolog & Terapist',
    category: 'Kurumsal',
    description: 'Psikologlar için güven veren tasarıma sahip, online veya yüz yüze seans rezervasyon sistemi.',
    url: 'https://psikolog.patoyazilim.com',
    image: '/images/demo-psikolog.webp',
    features: ['Takvim ve Randevu Sistemi', 'Blog Modülü', 'Uzman Profili Sayfası', 'Gizlilik Politikası Uyumlu']
  },
  {
    id: 'guzellik',
    title: 'Kuaför & Güzellik Merkezi',
    category: 'Kurumsal',
    description: 'Güzellik merkezleri ve kuaförler için hizmet menüsü ve personel bazlı randevu sistemi sunan web platformu.',
    url: 'https://guzellik.patoyazilim.com',
    image: '/images/demo-guzellik.webp',
    features: ['Personel Bazlı Randevu', 'Hizmet Fiyat Listesi', 'Instagram Akışı', 'Kampanya Modülü']
  },
  {
    id: 'rezervasyon',
    title: 'Gelişmiş Rezervasyon',
    category: 'Özel Yazılım',
    description: 'Otel, tur veya etkinlik biletlemesi için uçtan uca online rezervasyon ve takvim yönetim sistemi.',
    url: 'https://rezervasyon.patoyazilim.com',
    image: '/images/demo-rezervasyon.webp',
    features: ['Takvim Entegrasyonu', 'Online Ödeme Altyapısı', 'Müsaitlik Durumu', 'Otomatik E-posta & SMS']
  },
  {
    id: 'spor-salonu',
    title: 'Spor Salonu & Pilates',
    category: 'Kurumsal',
    description: 'Fitness salonları ve pilates stüdyoları için üyelik paketleri, ders programı ve eğitmen rezervasyonu.',
    url: 'https://studio.patoyazilim.com',
    image: '/images/demo-studio.webp',
    features: ['Ders Programı Takvimi', 'Üyelik Paketleri Satışı', 'Eğitmen Profilleri', 'Online Ders Rezervasyonu']
  },
  {
    id: 'restoran',
    title: 'Restoran & Cafe',
    category: 'Kurumsal',
    description: 'Restoranlar için şık tasarımlı, dijital menü gösterimi ve online masa/paket servis rezervasyon altyapısı.',
    url: 'https://restoran.patoyazilim.com',
    image: '/images/demo-restoran.webp',
    features: ['Menü Kategorizasyonu', 'Masa Rezervasyonu', 'Çoklu Şube Desteği', 'Mobil Uyumlu Tasarım']
  },
  {
    id: 'burger',
    title: 'Burger & Fast Food',
    category: 'E-Ticaret',
    description: 'Fast food işletmeleri için hızlı sipariş verme (paket servis/gel al) ve kampanya yönetim odaklı modern site.',
    url: 'https://burger.patoyazilim.com',
    image: '/images/demo-burger.webp',
    features: ['Hızlı Online Sipariş', 'Sepet İçi Ekstralar (Upsell)', 'Kampanya/Promosyon Kodu', 'Teslimat Bölgesi Sınırlandırma']
  },
  {
    id: 'qr-menu',
    title: 'Dinamik QR Menü',
    category: 'Özel Yazılım',
    description: 'Mekandaki masalara özel QR kod ile okutulabilen, kolayca güncellenebilir çok dilli dijital menü sistemi.',
    url: 'https://qrmenu.patoyazilim.com',
    image: '/images/demo-qrmenu.webp',
    features: ['Karekod Üretimi', 'Çoklu Dil (TR/EN/AR)', 'Kategori Bazlı Listeleme', 'Anlık Fiyat Güncelleme']
  },
  {
    id: 'finans-raporlama',
    title: 'Finansal Raporlama Paneli',
    category: 'Özel Yazılım',
    description: 'Kurumsal firmalar için gelir/gider, nakit akışı ve kar/zarar durumunu anlık grafiklerle sunan finansal dashboard.',
    url: 'https://finans.patoyazilim.com',
    image: '/images/demo-finans.webp',
    features: ['Gelişmiş Veri Görselleştirme', 'Excel/PDF Dışa Aktarım', 'Kullanıcı Rolleri Yetkilendirmesi', 'Banka Entegrasyonu Altyapısı']
  }
];
